const langObj = {
  af: 'Afrikaans',
  'af-ZA': 'Afrikaans (South Africa)',
  ar: 'Arabic',
  'ar-AE': 'Arabic (U.A.E.)',
  'ar-BH': 'Arabic (Bahrain)',
  'ar-DZ': 'Arabic (Algeria)',
  'ar-EG': 'Arabic (Egypt)',
  'ar-IQ': 'Arabic (Iraq)',
  'ar-JO': 'Arabic (Jordan)',
  'ar-KW': 'Arabic (Kuwait)',
  'ar-LB': 'Arabic (Lebanon)',
  'ar-LY': 'Arabic (Libya)',
  'ar-MA': 'Arabic (Morocco)',
  'ar-OM': 'Arabic (Oman)',
  'ar-QA': 'Arabic (Qatar)',
  'ar-SA': 'Arabic (Saudi Arabia)',
  'ar-SY': 'Arabic (Syria)',
  'ar-TN': 'Arabic (Tunisia)',
  'ar-YE': 'Arabic (Yemen)',
  az: 'Azeri (Latin)',
  'az-AZ': 'Azeri (Cyrillic) (Azerbaijan)',
  be: 'Belarusian',
  'be-BY': 'Belarusian (Belarus)',
  bg: 'Bulgarian',
  'bg-BG': 'Bulgarian (Bulgaria)',
  'bs-BA': 'Bosnian (Bosnia and Herzegovina)',
  ca: 'Catalan',
  'ca-ES': 'Catalan (Spain)',
  cs: 'Czech',
  'cs-CZ': 'Czech (Czech Republic)',
  cy: 'Welsh',
  'cy-GB': 'Welsh (United Kingdom)',
  da: 'Danish',
  'da-DK': 'Danish (Denmark)',
  de: 'German',
  'de-AT': 'German (Austria)',
  'de-CH': 'German (Switzerland)',
  'de-DE': 'German (Germany)',
  'de-LI': 'German (Liechtenstein)',
  'de-LU': 'German (Luxembourg)',
  dv: 'Divehi',
  'dv-MV': 'Divehi (Maldives)',
  el: 'Greek',
  'el-GR': 'Greek (Greece)',
  en: 'English',
  'en-AU': 'English (Australia)',
  'en-BZ': 'English (Belize)',
  'en-CA': 'English (Canada)',
  'en-CB': 'English (Caribbean)',
  'en-GB': 'English (United Kingdom)',
  'en-IE': 'English (Ireland)',
  'en-JM': 'English (Jamaica)',
  'en-NZ': 'English (New Zealand)',
  'en-PH': 'English (Republic of the Philippines)',
  'en-TT': 'English (Trinidad and Tobago)',
  'en-US': 'English (United States)',
  'en-ZA': 'English (South Africa)',
  'en-ZW': 'English (Zimbabwe)',
  eo: 'Esperanto',
  es: 'Spanish',
  'es-AR': 'Spanish (Argentina)',
  'es-BO': 'Spanish (Bolivia)',
  'es-CL': 'Spanish (Chile)',
  'es-CO': 'Spanish (Colombia)',
  'es-CR': 'Spanish (Costa Rica)',
  'es-DO': 'Spanish (Dominican Republic)',
  'es-EC': 'Spanish (Ecuador)',
  'es-ES': 'Spanish (Spain)',
  'es-GT': 'Spanish (Guatemala)',
  'es-HN': 'Spanish (Honduras)',
  'es-MX': 'Spanish (Mexico)',
  'es-NI': 'Spanish (Nicaragua)',
  'es-PA': 'Spanish (Panama)',
  'es-PE': 'Spanish (Peru)',
  'es-PR': 'Spanish (Puerto Rico)',
  'es-PY': 'Spanish (Paraguay)',
  'es-SV': 'Spanish (El Salvador)',
  'es-UY': 'Spanish (Uruguay)',
  'es-VE': 'Spanish (Venezuela)',
  et: 'Estonian',
  'et-EE': 'Estonian (Estonia)',
  eu: 'Basque',
  'eu-ES': 'Basque (Spain)',
  fa: 'Farsi',
  'fa-IR': 'Farsi (Iran)',
  fi: 'Finnish',
  'fi-FI': 'Finnish (Finland)',
  fo: 'Faroese',
  'fo-FO': 'Faroese (Faroe Islands)',
  fr: 'French',
  'fr-BE': 'French (Belgium)',
  'fr-CA': 'French (Canada)',
  'fr-CH': 'French (Switzerland)',
  'fr-FR': 'French (France)',
  'fr-LU': 'French (Luxembourg)',
  'fr-MC': 'French (Principality of Monaco)',
  gl: 'Galician',
  'gl-ES': 'Galician (Spain)',
  gu: 'Gujarati',
  'gu-IN': 'Gujarati (India)',
  he: 'Hebrew',
  'he-IL': 'Hebrew (Israel)',
  hi: 'Hindi',
  'hi-IN': 'Hindi (India)',
  hr: 'Croatian',
  'hr-BA': 'Croatian (Bosnia and Herzegovina)',
  'hr-HR': 'Croatian (Croatia)',
  hu: 'Hungarian',
  'hu-HU': 'Hungarian (Hungary)',
  hy: 'Armenian',
  'hy-AM': 'Armenian (Armenia)',
  id: 'Indonesian',
  'id-ID': 'Indonesian (Indonesia)',
  is: 'Icelandic',
  'is-IS': 'Icelandic (Iceland)',
  it: 'Italian',
  'it-CH': 'Italian (Switzerland)',
  'it-IT': 'Italian (Italy)',
  ja: 'Japanese',
  'ja-JP': 'Japanese (Japan)',
  ka: 'Georgian',
  'ka-GE': 'Georgian (Georgia)',
  kk: 'Kazakh',
  'kk-KZ': 'Kazakh (Kazakhstan)',
  kn: 'Kannada',
  'kn-IN': 'Kannada (India)',
  ko: 'Korean',
  'ko-KR': 'Korean (Korea)',
  kok: 'Konkani',
  'kok-IN': 'Konkani (India)',
  ky: 'Kyrgyz',
  'ky-KG': 'Kyrgyz (Kyrgyzstan)',
  lt: 'Lithuanian',
  'lt-LT': 'Lithuanian (Lithuania)',
  lv: 'Latvian',
  'lv-LV': 'Latvian (Latvia)',
  mi: 'Maori',
  'mi-NZ': 'Maori (New Zealand)',
  mk: 'FYRO Macedonian',
  'mk-MK': 'FYRO Macedonian (Former Yugoslav Republic of Macedonia)',
  mn: 'Mongolian',
  'mn-MN': 'Mongolian (Mongolia)',
  mr: 'Marathi',
  'mr-IN': 'Marathi (India)',
  ms: 'Malay',
  'ms-BN': 'Malay (Brunei Darussalam)',
  'ms-MY': 'Malay (Malaysia)',
  mt: 'Maltese',
  'mt-MT': 'Maltese (Malta)',
  nb: 'Norwegian (Bokm?l)',
  'nb-NO': 'Norwegian (Bokm?l) (Norway)',
  nl: 'Dutch',
  'nl-BE': 'Dutch (Belgium)',
  'nl-NL': 'Dutch (Netherlands)',
  'nn-NO': 'Norwegian (Nynorsk) (Norway)',
  ns: 'Northern Sotho',
  'ns-ZA': 'Northern Sotho (South Africa)',
  pa: 'Punjabi',
  'pa-IN': 'Punjabi (India)',
  pl: 'Polish',
  'pl-PL': 'Polish (Poland)',
  ps: 'Pashto',
  'ps-AR': 'Pashto (Afghanistan)',
  pt: 'Portuguese',
  'pt-BR': 'Portuguese (Brazil)',
  'pt-PT': 'Portuguese (Portugal)',
  qu: 'Quechua',
  'qu-BO': 'Quechua (Bolivia)',
  'qu-EC': 'Quechua (Ecuador)',
  'qu-PE': 'Quechua (Peru)',
  ro: 'Romanian',
  'ro-RO': 'Romanian (Romania)',
  ru: 'Russian',
  'ru-RU': 'Russian (Russia)',
  sa: 'Sanskrit',
  'sa-IN': 'Sanskrit (India)',
  se: 'Sami (Northern)',
  'se-FI': 'Sami (Inari) (Finland)',
  'se-NO': 'Sami (Southern) (Norway)',
  'se-SE': 'Sami (Southern) (Sweden)',
  sk: 'Slovak',
  'sk-SK': 'Slovak (Slovakia)',
  sl: 'Slovenian',
  'sl-SI': 'Slovenian (Slovenia)',
  sq: 'Albanian',
  'sq-AL': 'Albanian (Albania)',
  'sr-BA': 'Serbian (Cyrillic) (Bosnia and Herzegovina)',
  'sr-SP': 'Serbian (Cyrillic) (Serbia and Montenegro)',
  sv: 'Swedish',
  'sv-FI': 'Swedish (Finland)',
  'sv-SE': 'Swedish (Sweden)',
  sw: 'Swahili',
  'sw-KE': 'Swahili (Kenya)',
  syr: 'Syriac',
  'syr-SY': 'Syriac (Syria)',
  ta: 'Tamil',
  'ta-IN': 'Tamil (India)',
  te: 'Telugu',
  'te-IN': 'Telugu (India)',
  th: 'Thai',
  'th-TH': 'Thai (Thailand)',
  tl: 'Tagalog',
  'tl-PH': 'Tagalog (Philippines)',
  tn: 'Tswana',
  'tn-ZA': 'Tswana (South Africa)',
  tr: 'Turkish',
  'tr-TR': 'Turkish (Turkey)',
  tt: 'Tatar',
  'tt-RU': 'Tatar (Russia)',
  ts: 'Tsonga',
  uk: 'Ukrainian',
  'uk-UA': 'Ukrainian (Ukraine)',
  ur: 'Urdu',
  'ur-PK': 'Urdu (Islamic Republic of Pakistan)',
  uz: 'Uzbek (Latin)',
  'uz-UZ': 'Uzbek (Cyrillic) (Uzbekistan)',
  vi: 'Vietnamese',
  'vi-VN': 'Vietnamese (Viet Nam)',
  xh: 'Xhosa',
  'xh-ZA': 'Xhosa (South Africa)',
  zh: 'Chinese',
  'zh-CN': 'Chinese (S)',
  'zh-HK': 'Chinese (Hong Kong)',
  'zh-MO': 'Chinese (Macau)',
  'zh-SG': 'Chinese (Singapore)',
  'zh-TW': 'Chinese (T)',
  zu: 'Zulu',
  'zu-ZA': 'Zulu (South Africa)',
};

// 新增：常用语言配置（用于界面语言选择）
export const COMMON_LANGUAGES = [
  'en', // English
  'zh', // Chinese
  'ja', // Japanese
  'ko', // Korean
];

// 新增：原生语言名称映射（用于显示本地化名称）
export const NATIVE_LANGUAGE_NAMES = {
  en: 'English',
  zh: '中文',
  ja: '日本語',
  ko: '한국어',
  // 移除其他语言的映射，只保留这四种
};

// 新增：获取语言信息的安全函数
export const getLanguageInfo = (code) => {
  const baseCode = code.split('-')[0]; // 获取基础语言代码
  const englishName = langObj[code] || langObj[baseCode] || 'Unknown';
  const nativeName = NATIVE_LANGUAGE_NAMES[code] || NATIVE_LANGUAGE_NAMES[baseCode] || englishName;

  return {
    code,
    name: englishName,
    local: nativeName,
    nativeName: nativeName,
    isCommon: COMMON_LANGUAGES.includes(baseCode)
  };
};

// 新增：语言映射对象（用于快速查找）
export const LANGUAGE_MAP = COMMON_LANGUAGES.reduce((acc, code) => {
  const info = getLanguageInfo(code);
  acc[code] = {
    name: info.name,
    local: info.local,
    nativeName: info.nativeName
  };
  return acc;
}, {});



// 新增：获取所有常用语言选项
export const getCommonLanguageOptions = () => {
  return COMMON_LANGUAGES.map(code => {
    const info = getLanguageInfo(code);
    return {
      value: code,
      label: info.name,
      localName: info.local,
      nativeName: info.nativeName
    };
  }).sort((a, b) => a.label.localeCompare(b.label));
};

// 新增：获取所有可用语言选项
export const getAllLanguageOptions = () => {
  const allCodes = Object.keys(langObj);
  return allCodes.map(code => {
    const info = getLanguageInfo(code);
    return {
      value: code,
      label: info.name,
      localName: info.local,
      nativeName: info.nativeName,
      isCommon: info.isCommon
    };
  }).sort((a, b) => a.label.localeCompare(b.label));
};

// 新增：检测浏览器语言
export const detectBrowserLanguage = () => {
  const browserLang = navigator.language || navigator.languages?.[0] || 'en';

  // 首先检查完整的语言代码
  if (langObj[browserLang]) {
    return browserLang;
  }

  // 然后检查基础语言代码
  const langCode = browserLang.split('-')[0];
  if (COMMON_LANGUAGES.includes(langCode)) {
    return langCode;
  }

  return 'en'; // 默认返回英语
};

// 新增：格式化语言显示
export const formatLanguageDisplay = (code, showLocal = true) => {
  const info = getLanguageInfo(code);
  if (showLocal && info.local !== info.name) {
    return `${info.name} (${info.local})`;
  }
  return info.name;
};

// 新增：多语言文本配置
export const MULTILINGUAL_TEXTS = {
  en: {
    // 筛选相关
    timeRange: 'Time Range:',
    game: 'Game:',
    allGames: 'All Games',
    sort: 'Sort:',
    search: 'Search:',
    searchPlaceholder: 'Search username or Twitch username...',
    more: 'More',
    gameTags: 'Game Tags',
    gameType: 'Game Type:',
    gameTheme: 'Game Theme:',
    addType: 'Add Type',
    addTheme: 'Add Theme',

    // 用户列表相关
    userList: 'User List ({{count}} users)',
    selectedUsers: '- Selected {{count}} users',
    oneClickSelect: 'One-Click Select',
    addToPackage: 'Add to Streamer Package',
    clearSelection: 'Clear Selection',

    // 排序选项
    matchScore: 'Match Score',
    activityLevel: 'Activity Level',
    executionAbility: 'Execution Ability',
    costEffectiveness: 'Cost Effectiveness',
    followers: 'Followers',
    avgViewers: 'Average Viewers',

    // 主播类型
    unlimited: 'Unlimited',
    premiumStreamer: 'Premium Streamer',
    potentialStreamer: 'Potential Streamer',
    normalStreamer: 'Normal Streamer',
    otherStreamers: 'Other Streamers',

    // 评价标签
    activity: 'Activity',
    execution: 'Execution',
    costEffect: 'Cost-Effect',
    noRating: 'No Rating',

    // 消息
    loadingUsers: 'Loading user data...',
    noUsers: 'No matching users found',
    addedToSelection: 'Added {{count}} users from current page to selection list',
    clearedSelection: 'Cleared selection of {{count}} users',

    // 语言相关
    languageSettings: 'Language Settings',
    interfaceLanguage: 'Interface Language',
    contentLanguage: 'Content Language',
    autoDetect: 'Auto Detect',

    // 添加缺失的翻译
    language: 'Language',
    streamerFilterSystem: 'Streamer Filter System',
    streamerGroupManagement: 'Streamer Group Management',
    streamerPackageSystem: 'Streamer Package Management System',
    groupList: 'Group List',
    addGroup: 'Add Group',
    loadingGroups: 'Loading groups...',
    noGroups: 'No groups available',
    memberCount: '{{count}} members',
    edit: 'Edit',
    delete: 'Delete',
    days: 'days',
    tags: 'tags',
    noTags: 'No Tags',
    search: 'Search',
    rowsPerPage: 'Rows per page:',
    displayedRows: '{{from}}-{{to}} of {{count}}',
    close: 'Close',
    current: 'Current',

    // 添加 StreamerGroupManager 需要的翻译
    totalGames: 'Total Games',
    totalGroups: 'Total Groups',
    totalPackages: 'Total Packages',
    totalStreamers: 'Total Streamers',
    existingGroups: 'Existing Groups ({{count}} groups)',
    streamers: 'Streamers',
    packages: 'Packages',
    viewExpectedData: 'View Expected Data',
    sendTaskInvitation: 'Send Task Invitation',
    viewDays: 'View Days:',
    switchingToPackage: 'Switching to "{{name}}"...',
    loadingStreamerData: 'Loading streamer data...',
    streamerList: 'Streamer List ({{count}} streamers)',
    selected: 'Selected {{count}}',
    oneClickSelect: 'One-Click Select',
    transferToOtherPackage: 'Transfer to Other Package ({{count}})',
    deleteSelected: 'Delete Selected ({{count}})',
    clearSelection: 'Clear Selection',
    selectedStreamers: 'Selected streamers:',
    noOtherPackagesAvailable: '⚠️ No other packages available in current group, cannot transfer',
    noStreamers: 'No Streamers',
    noStreamersInPackage: 'This package currently has no streamers',
    pleaseSelectGroupAndPackage: 'Please select a group and package',
    selectGroupAndPackageToView: 'Select a group and package from the left to view streamer list',
    packageNotExists: 'Package does not exist',
    currentSelectedPackageInvalid: 'Current selected package index is invalid',
    searchGroups: 'Search groups...',
    groupManagementHome: 'Group Management Home',
    refreshing: 'Refreshing...',
    noMatchingGroups: 'No matching groups found',
    noGroupData: 'No group data available',
    createPackage: 'Create Package',
    editPackage: 'Edit Package',
    deletePackage: 'Delete Package',
    confirmDeletePackage: 'Confirm Delete Package',
    confirmDeletePackageMessage: 'Are you sure you want to delete package "{{name}}"?',
    cannotUndoOperation: '⚠️ This operation cannot be undone, all streamer data in the package will be cleared',
    deleting: 'Deleting...',
    confirmDelete: 'Confirm Delete',
    autoGenerateDefaultGroups: 'Auto Generate Default Groups',
    packageBasicInfo: 'Basic Information',
    packageName: 'Package Name',
    enterPackageName: 'Please enter package name...',
    packageDescription: 'Package Description',
    enterPackageDescription: 'Please enter package description...',
    packageSettings: 'Package Settings',
    maxStreamers: 'Max Streamers',
    priority: 'Priority',
    higherNumberHigherPriority: 'Higher number = higher priority',
    visibilityLevel: 'Visibility Level',
    tags: 'Tags',
    enterTagsCommaSeparated: 'Enter tags, separated by commas',
    tagsExample: 'e.g.: Premium, Popular, Beginner',
    streamerManagement: 'Streamer Management',
    currentlySelected: 'Currently selected {{count}} streamers',
    streamerListAutoGenerated: '* Streamer list will be auto-generated based on package settings and filter criteria',
    packageStats: 'Package Statistics:',
    actualStreamers: 'Actual Streamers: {{count}}',
    averageViewers: 'Average Viewers: {{count}}',
    totalFollowers: 'Total Followers: {{count}}',
    calculationPeriod: 'Calculation Period: {{period}}',
    processing: 'Processing...',
    create: 'Create',
    update: 'Update',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    transferUsersToOtherPackage: 'Transfer Users to Other Package',
    transferInfo: 'Transfer Information',
    gameGroup: 'Game Group:',
    currentPackage: 'Current Package:',
    selectedUsersCount: 'Selected Users:',
    selectTargetPackage: 'Select Target Package',
    transferInstructions: 'Transfer Instructions:',
    transferInstruction1: '• Users will be removed from current package and added to target package',
    transferInstruction2: '• Transfer operation cannot be undone, please confirm correct target package',
    transferInstruction3: '• Data will be automatically refreshed after transfer completion',
    confirmTransfer: 'Confirm Transfer',
    transferring: 'Transferring...',
    noActiveQuests: 'No Active Quests',
    noActiveQuestsForGame: 'Current game has no available active quests',
    loadingActiveQuests: 'Loading active quests...',
    sendTaskInvitationTo: 'Send task invitation to {{count}} streamers:',
    selectTasksToSend: 'Select tasks to send',
    totalTasks: 'Total {{total}} tasks, selected {{selected}}',
    selectAllTasks: 'Select All Tasks',
    deselectAllTasks: 'Deselect All',
    taskOverview: 'Task Overview',
    totalTasksCount: 'Total Tasks',
    selectedTasks: 'Selected',
    streamingTasks: 'Streaming Tasks',
    creationTasks: 'Creation Tasks',
    urgentTasks: 'Urgent Tasks',
    startTime: 'Start Time',
    endTime: 'End Time',
    taskType: 'Task Type',
    requiredStreamTime: 'Required Stream Time',
    notSet: 'Not Set',
    noRequirement: 'No Requirement',
    streamingTask: 'Streaming Task',
    creationTask: 'Creation Task',
    contentCreation: 'Content Creation',
    promotionTask: 'Promotion Task',
    eventTask: 'Event Task',
    unknownType: 'Unknown Type',
    urgent: 'Urgent',
    minimumViewers: 'Minimum Viewers: {{count}}',
    rewards: 'Rewards:',
    sendPreview: 'Send Preview:',
    willSendInvitationEmail: 'Will send invitation email containing {{taskCount}} tasks to {{userCount}} streamers',
    selectedTasksList: 'Selected tasks:',
    sendInvitation: 'Send Invitation ({{count}} streamers)',
    sending: 'Sending...',
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    unknownUser: 'Unknown User',
    expectedDataStats: 'Expected Data Statistics',
    statsOverview: 'Statistics Overview',
    group: 'Group:',
    package: 'Package:',
    statsPeriod: 'Statistics Period:',
    calculationTime: 'Calculation Time:',
    streamersCount: 'Streamers',
    averageCCV: 'Average CCV',
    peakCCV: 'Peak CCV',
    totalFollowersCount: 'Total Followers',
    detailedStats: 'Detailed Statistics',
    streamingTimeStats: 'Streaming Time Statistics',
    totalStreamingTime: 'Total Streaming Time:',
    avgStreamingTimePerStreamer: 'Avg Streaming Time per Streamer:',
    viewingDataStats: 'Viewing Data Statistics',
    totalViewingTime: 'Total Viewing Time:',
    vodViews: 'VOD Views:',
    dataExplanation: 'Data Explanation:',
    dataNote1: '• Above data is calculated and predicted based on selected streamers\' performance in the past {{days}} days',
    dataNote2: '• Average CCV is calculated based on streamers\' ACCV data',
    dataNote3: '• Peak CCV, viewing time and other metrics are predicted based on historical data and algorithm models',
    dataNote4: '• Actual data may vary due to streamer performance, game popularity and other factors',
    calculatingExpectedData: 'Calculating expected data...',
    basedOnRecentDaysData: 'Based on streamer data from the past {{days}} days for analysis',
    dataCalculationFailed: 'Data calculation failed',
    retryOrContactSupport: 'Please retry or contact technical support',
    refreshData: 'Refresh Data',
    // 新增翻译
    autoGenerateComplete: 'Auto generation completed: Created {{groups}} groups and {{packages}} packages',
    noNewGroupsOrPackages: 'No new groups or packages need to be created',
    autoGenerationFailed: 'Auto generation failed: {{error}}',
    processingAutoGeneration: 'Processing auto generation...',
    thisOperationWillCreate: 'This operation will automatically create default groups and packages for all eligible games.',
    onlyCreateForGamesWithoutDefault: '• Only create new groups for games without default groups',
    onlyCreateForGroupsWithoutDefault: '• Only create new packages for groups without default packages',
    onlyProcessActiveGamesWithTwitch: '• Only process games with status "active" and nameInTwitch',
    operationCannotBeUndone: '⚠️ This operation cannot be undone, please proceed with caution',
    generating: 'Generating...',
    autoGeneratingGroupsAndPackages: 'Auto generating groups and packages...',
    thisCouldTakeMinutes: 'Please wait, this may take several minutes',
    generationResults: 'Generation Results',
    processedGames: 'Processed Games:',
    createdGroups: 'Created Groups:',
    createdPackages: 'Created Packages:',
    successfullyProcessed: 'Successfully Processed:',
    failedProcessed: 'Failed Processed:',
    successRate: 'Success Rate: {{rate}}',
    operator: 'Operator: {{username}}',
    startGeneration: 'Start Generation',
    completed: 'Completed',
    //----------- 主播包补充翻译的-------------

    // 时间范围
    '30days': '30 Days',
    '60days': '60 Days', 
    '90days': '90 Days',
    '120days': '120 Days',
    '365days': '365 Days',
    'days': 'Days',

    // 筛选相关
    timeRange: 'Time Range:',
    game: 'Game:',
    allGames: 'All Games',
    sort: 'Sort:',
    search: 'Search:',
    searchPlaceholder: 'Search username or Twitch username...',
    more: 'More',
    gameTags: 'Game Tags',
    gameType: 'Game Type:',
    gameTheme: 'Game Theme:',
    addType: 'Add Type',
    addTheme: 'Add Theme',

    // 排序选项
    matchScore: 'Match Score',
    activityLevel: 'Activity Level',
    executionAbility: 'Execution Ability',
    costEffectiveness: 'Cost Effectiveness',
    followers: 'Followers',
    avgViewers: 'Average Viewers',

    // 主播类型
    streamerType: 'Streamer Type:',
    unlimited: 'Unlimited',
    premiumStreamer: 'Premium Streamer',
    potentialStreamer: 'Potential Streamer', 
    normalStreamer: 'Normal Streamer',
    otherStreamers: 'Other Streamers',

    // 卡片内容
    followersLabel: 'Followers',
    activity: 'Activity',
    execution: 'Execution',
    costEffect: 'Cost-Effect',
    matchDegree: 'Match',
    noRating: 'No Rating',

    // 搜索按钮
    searchBtn: 'Search',

    // More 菜单项
    syncStreamerRatings: 'Sync Streamer Ratings',
    syncGameTags: 'Sync Game Tags', 
    syncGameInfo: 'Sync Game Info',

    // 弹窗内容 - 主播评价体系管理
    streamerRatingSystemManagement: 'Streamer Rating System Management',
    syncTags: 'Sync Tags',
    systemConfig: 'System Configuration',
    syncStreamerRatingTags: 'Sync Streamer Rating Tags',
    syncAllStreamerRatingDesc: 'Sync all streamers\' rating tag data, including activity level, completion ability and cost effectiveness indicators.',
    currentConfigOverview: 'Current Configuration Overview',
    tagTypesCount: 'Tag Types Total',
    activeTagsCount: 'Active Tags',
    totalTagsCount: 'Total Tags',
    tagTypesOverview: 'Tag Types Overview',
    noConfigData: 'No configuration data',
    syncOptionSettings: 'Sync Option Settings',
    forceUpdateAllUsers: 'Force Update All Users',
    forceUpdateDesc: 'When checked, will force update all streamers\' rating tags, including users with existing ratings. When unchecked, will skip users with existing ratings and only update new users or users with missing ratings.',
    startSyncTags: 'Start Sync Tags',
    viewDetailedConfig: 'View Detailed Configuration',
    forceUpdateMode: 'Force update mode: Will recalculate all streamers\' rating tags, this process may take a long time.',
    smartUpdateMode: 'Smart update mode: Only update new users or users with missing ratings, can save time.',
    tagTypeConfig: 'Tag Type Configuration',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving...',
    saveTypeConfig: 'Save Type Configuration',
    editTypeConfig: 'Edit Type Configuration',
    typeCode: 'Type Code',
    typeName: 'Type Name',
    defaultStatDays: 'Default Stat Days',
    description: 'Description',
    noTagTypeData: 'No tag type data',
    tagDetailedConfig: 'Tag Detailed Configuration',
    saveTagConfig: 'Save Tag Configuration',
    editTagConfig: 'Edit Tag Configuration',
    initializeSystem: 'Initialize System',
    initializing: 'Initializing...',
    tagCode: 'Tag Code',
    tagName: 'Tag Name',
    category: 'Category',
    registrationTime: 'Registration Time',
    recentApplicationDays: 'Recent Application Days',
    applicationRatio: 'Application Ratio',
    recentCompletionDays: 'Recent Completion Days',
    completionRatio: 'Completion Ratio',
    completionRateRatio: 'Completion Rate Ratio',
    rewardRatio: 'Reward Ratio',
    priority: 'Priority',
    status: 'Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    noTagConfigData: 'No tag configuration data',
    editInstructions: 'Edit Instructions:',
    editInstructionsDesc: '• Tag type configuration: Can edit default stat days and description\n• Tag detailed configuration: Can edit tag name and registration time range\n• 110-150 tags: Can edit application ratio range\n• 210-250 tags: Can edit completion ratio and completion rate ratio range\n• 310-350 tags: Can edit completion rate ratio and reward ratio range',

    // 弹窗内容 - 游戏标签同步
    syncGameTagsTitle: 'Sync Game Tags',
    selectGameTagTimeRange: 'Select the game tag time range to sync, the system will recalculate user game preference tags for the selected time ranges.',
    updateAllTimeRanges: 'Update All Time Ranges',
    updateAllTimeRangesDesc: 'When checked, all time ranges (30, 60, 90, 120, 365 days) tags will be updated, ignoring the specific selections below.',
    selectGameTagRanges: 'Select Game Tag Ranges (Multiple Selection):',
    allRangesSelected: 'All ranges selected for update, selections below will be ignored',
    pleaseSelectAtLeastOne: 'Please select at least one time range',
    willUpdateAllRanges: 'Will update all time ranges (30, 60, 90, 120, 365 days) tags',
    selectedRanges: 'Selected {{count}} time ranges: {{ranges}} days',
    syncLatestData: 'Sync Latest Data',
    syncLatestDataDesc: 'If checked, will fetch latest game data from data source before recalculating tags. If unchecked, will only recalculate tags based on existing data without updating game data.',
    syncProcessDesc: 'Sync process may take several minutes, depending on user count and selected ranges.',
    updateAllRangesTakeLonger: 'Updating all ranges may take longer time.',
    startSync: 'Start Sync',
    syncing: 'Syncing...',

    // 弹窗内容 - 游戏信息同步
    gameIGDBInfoSync: 'Game IGDB Info Sync',
    syncConfig: 'Sync Configuration',
    selectGameSource: 'Select Game Source',
    allGames: 'All Games',
    noizPlatformGames: 'Noiz Platform Games',
    nonNoizPlatformGames: 'Non-Noiz Platform Games',
    allGamesDesc: 'Get all game data from UserGame table',
    noizGamesDesc: 'Get platform certified games from Game table',
    nonNoizGamesDesc: 'Other games excluding platform games',
    statDays: 'Stat Days',
    syncMode: 'Sync Mode',
    smartSync: 'Smart Sync (Unsynced Only)',
    forceSync: 'Force Sync (Synced Only)',
    fullSync: 'Full Sync (All Games)',
    searchGames: 'Search Games...',
    searchGame: 'Search Games',
    statsOverview: 'Statistics Overview',
    loadingData: 'Loading data...',
    totalGamesCount: 'Total Games',
    synced: 'Synced',
    unsynced: 'Unsynced',
    syncRate: 'Sync Rate',
    gameList: 'Game List',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    selectedCount: 'Selected {{count}}',
    gameListEmpty: 'No matching games found',
    loadingGameData: 'Loading game data...',
    noGameData: 'No games found',
    operationInstructions: 'Operation Instructions',
    operationInstructionsDesc: '• Select games and click "Start Sync", if none selected will sync all matching games\n• Smart sync: Skip games with existing IGDB info\n• Force sync: Re-fetch games with existing IGDB info\n• Full sync: Process all games, decide whether to overwrite based on existing status',
    syncInProgress: 'Syncing...',
    syncIGDBInfo: 'Sync IGDB Info',
    currentProcessing: 'Current: {{game}}',
    progress: 'Progress: {{processed}}/{{total}}',

    // 用户列表相关
    userList: 'User List ({{count}} users)',
    selectedUsers: '- Selected {{count}} users',
    oneClickSelect: 'One-Click Select',
    addToPackage: 'Add to Streamer Package',
    clearSelection: 'Clear Selection',

    // 消息
    loadingUsers: 'Loading user data...',
    noUsers: 'No matching users found',
    addedToSelection: 'Added {{count}} users from current page to selection list',
    clearedSelection: 'Cleared selection of {{count}} users',

    // 语言相关
    languageSettings: 'Language Settings',
    interfaceLanguage: 'Interface Language',
    contentLanguage: 'Content Language',
    autoDetect: 'Auto Detect',

    // 只添加真正缺失的翻译
    addToStreamerPackage: 'Add to Streamer Package',
    selectedUsersCount: 'Selected {{count}} users',
    selectedUsersList: 'Selected users list:',
    typeDistribution: 'Type distribution:',
    selectionPersistence: 'Selection persistence: User selections will persist when paginating or filtering, you can manually click tag delete icon to remove individual users',
    clickToAddToPackage: 'Click "Add to Streamer Package" to batch add selected users to specified game streamer package',
    
    currentFilters: 'Current Filters',
    clearAllFilters: 'Clear All Filters',
    filterPersistence: 'Filter results will persist across pages',
    
    match: 'Match',
    viewStats: 'View Stats',
    
    // 主播包弹窗相关
    addUsersToStreamerPackage: 'Add Users to Streamer Package',
    aboutToAdd: 'About to add {{count}} users to streamer package:',
    searchAndSelectGameGroup: '1. Search and select game group',
    enterGameNameToSearch: 'Enter game name to search...',
    selectedGame: 'Selected game:',
    defaultGroup: 'Default Group: {{groupName}}',
    autoSelectedDefaultGroup: 'Auto-selected default group, found {{count}} available streamer packages',
    selectStreamerPackage: '2. Select streamer package',
    pleaseSelectGameFirst: 'Please select game first',
    gameHasNoDefaultGroup: 'This game has no default group',
    selectStreamerPackageOption: 'Select streamer package',
    noAvailablePackages: 'This group has no available streamer packages currently',
    addPreview: 'Add Preview:',
    willAddUsersToPackage: 'Will add {{userCount}} users to "{{packageName}}" package',
    packageCurrently: 'Package currently has {{current}} streamers, will have {{total}} after adding (limit: {{max}})',
    operationDescription: 'Operation description: Select game and then auto-select the default group for that game, then you can choose packages under the group',
    adding: 'Adding...',
    addUsers: 'Add {{count}} Users',
    
    // IGDB同步进度相关
    syncingIGDBInfo: 'Syncing IGDB info...',
    currentProcessing: 'Current processing: {{game}}',
    
    // 用户相关
    noRatingData: 'No rating data',
    unknownUser: 'Unknown User',
    
    // 数据相关
    gameCount: '{{count}} games',
    tagCount: '{{count}} tags', 
    userCount: '{{count}} users',
    items: 'items',
    // 其他的翻译
    // 数据加载页面
    loadingStreamerGroupData: 'Loading streamer group data...',
    loadingLatestGroupInfo: 'Please wait, loading latest group and streamer information',

    // 左侧栏
    streamers: 'streamers',
    streamer: 'streamer',
    streamersCount: '{{count}} streamers',
    streamerCount: '{{count}} streamer',

    // 自动生成相关
    autoGenerateDefaultGroups: 'Auto Generate Default Groups',
    autoGenerateDefaultGroupsAndPackages: 'Auto Generate Default Groups and Packages',
    thisOperationWillCreate: 'This operation will automatically create default groups and packages for all eligible games.',
    onlyCreateForGamesWithoutDefault: '• Only create new groups for games without default groups',
    onlyCreateForGroupsWithoutDefault: '• Only create new packages for groups without default packages',
    onlyProcessActiveGamesWithTwitch: '• Only process games with status "active" and nameInTwitch',
    operationCannotBeUndone: '⚠️ This operation cannot be undone, please proceed with caution',
    cancel: 'Cancel',
    startGeneration: 'Start Generation',
    generating: 'Generating...',
    autoGeneratingGroupsAndPackages: 'Auto generating groups and packages...',
    thisCouldTakeMinutes: 'Please wait, this may take several minutes',
    
    // 生成结果
    generationResults: 'Generation Results',
    processedGames: 'Processed Games:',
    createdGroups: 'Created Groups:',
    createdPackages: 'Created Packages:',
    successfullyProcessed: 'Successfully Processed:',
    failedProcessed: 'Failed Processed:',
    successRate: 'Success Rate: {{rate}}',
    operator: 'Operator: {{username}}',
    completed: 'Completed',

    platformUsers: 'NoizActiveUsers',
    platformUsersDesc: 'Noiz platform active users',

    // 主播包相关
    packageBasicInfo: 'Basic Information',
    packageName: 'Package Name',
    enterPackageName: 'Please enter package name...',
    packageDescription: 'Package Description',
    enterPackageDescription: 'Please enter package description...',
    packageSettings: 'Package Settings',
    maxStreamers: 'Max Streamers',
    priority: 'Priority',
    higherNumberHigherPriority: 'Higher number = higher priority',
    visibilityLevel: 'Visibility Level',
    tags: 'Tags',
    enterTagsCommaSeparated: 'Enter tags, separated by commas',
    tagsExample: 'e.g.: Premium, Popular, Beginner',
    streamerManagement: 'Streamer Management',
    currentlySelected: 'Currently selected {{count}} streamers',
    streamerListAutoGenerated: '* Streamer list will be auto-generated based on package settings and filter criteria',

    // 删除确认
    confirmDeletePackage: 'Confirm Delete Package',
    confirmDeletePackageMessage: 'Are you sure you want to delete package "{{name}}"?',
    cannotUndoOperation: '⚠️ This operation cannot be undone, all streamer data in the package will be cleared',
    deleting: 'Deleting...',
    confirmDelete: 'Confirm Delete',

    // 其他状态文本
    processing: 'Processing...',
    public: 'Public',
    private: 'Private',
    restricted: 'Restricted',
    create: 'Create',
    update: 'Update',
    refreshing: 'Refreshing...',

    // 数据加载成功提示
    loadedStreamersSuccess: 'Successfully loaded {{count}} streamers',
    loadedStreamerSuccess: 'Successfully loaded {{count}} streamer',
    loadDataFailed: 'Failed to load data',
    networkRequestFailed: 'Network request failed',

    syncGameTagsDesc: 'Recalculate and sync user game tags based on existing data in database',
    syncCurrentDataDesc: 'Calculate tags based on existing database data, no external data refresh needed',
    syncProcessTimeDesc: 'Sync time depends on user count and selected time ranges',
    syncProcessNote: 'Sync Instructions',
    pleaseSelectAtLeastOneRange: 'Please select at least one time range or check "Update All Ranges"',
    atLeastOneRangeRequired: 'At least one time range is required',
    syncSuccess: 'Sync successful! Processed {{count}} users in {{time}} seconds',
    syncGameTagsFailed: 'Failed to sync game tags',
    syncUserGameTagsFailed: 'Failed to sync user game tags',
    selectTimeRangeForTagUpdate: 'Please select time range tags to update, click "Sync" to start updating user game tags',
    selectUpdateRanges: 'Select tag ranges to update',
    canSelectMultipleRanges: 'Multiple selection allowed, will recalculate user game tags for selected time ranges',
    // Twitch 相关翻译
    openTwitchPage: 'Open Twitch Page',
    openSullyGnomeDataPage: 'Open SullyGnome Data Page',
    visitTwitchPage: 'Click to visit {{username}}\'s Twitch page',
    noTwitchInfo: 'No Twitch Info',
    
    // 统计弹窗相关翻译
    userStatistics: 'User Statistics',
    basicInfo: 'Basic Information',
    gamePreferences: 'Game Preferences',
    accountInfo: 'Account Information',
    username: 'Username',
    displayName: 'Display Name',
    registrationDate: 'Registration Date',
    lastActive: 'Last Active',
    accountType: 'Account Type',
    verificationStatus: 'Verification Status',
    verified: 'Verified',
    unverified: 'Unverified',
    
    // Twitch 信息
    twitchInfo: 'Twitch Information',
    twitchUsername: 'Twitch Username',
    twitchFollowers: 'Twitch Followers',
    twitchViews: 'Total Views',
    twitchCreatedAt: 'Twitch Created',
    averageViewers: 'Average Viewers',
    peakViewers: 'Peak Viewers',
    
    // 游戏标签
    gameTagsWeights: 'Game Tag Weights',
    genreTags: 'Genre Tags',
    themeTags: 'Theme Tags',
    tagWeight: 'Weight',
    noGameTags: 'No game tags available',
    
    // 主播评价
    streamerRatings: 'Streamer Ratings',
    activityRating: 'Activity Rating',
    completionRating: 'Completion Rating',
    costEffectivenessRating: 'Cost Effectiveness Rating',
    ratingCode: 'Rating Code',
    ratingDescription: 'Description',
    lastUpdated: 'Last Updated',
    noRatingsAvailable: 'No ratings available',
    
    // 统计数据
    statisticsData: 'Statistics Data',
    accvHistory: 'ACCV History (Last 30 Days)',
    followerGrowth: 'Follower Growth Trend',
    viewersCount: 'Viewers',
    followersCount: 'Followers',
    day: 'Day',
    date: 'Date',
    
    // 数据状态
    dataNotAvailable: 'Data not available',
    loadingData: 'Loading data...',
    noDataToDisplay: 'No data to display',
    
    // 匹配度相关
    matchAnalysis: 'Match Analysis',
    matchScore: 'Match Score',
    matchFactors: 'Match Factors',
    
    // 操作按钮
    refreshData: 'Refresh Data',
    exportData: 'Export Data',
    viewDetails: 'View Details',
    
    // 时间格式
    timeAgo: '{{time}} ago',
    justNow: 'Just now',
    minutesAgo: '{{minutes}} minutes ago',
    hoursAgo: '{{hours}} hours ago',
    daysAgo: '{{days}} days ago',
    monthsAgo: '{{months}} months ago',
    yearsAgo: '{{years}} years ago',
    
    // 统计弹窗相关翻译
    userStatistics: 'User Statistics',
    overview: 'Overview',
    gameTags: 'Game Tags',
    historicalTrend: 'Historical Trend',
    
    // 概览页面
    userOverview: 'User Overview',
    daysData: '{{days}}-day data',
    matchScore: 'Match Score',
    totalFollowers: 'Total Followers',
    avgViewers30: '30-day Average Viewers',
    totalGameTags: 'Total Game Tags',
    
    // 用户信息
    userInfo: 'User Information',
    username: 'Username',
    registrationTime: 'Registration Time',
    userStatus: 'User Status',
    region: 'Region',
    lastLogin: 'Last Login',
    languagePreference: 'Language Preference',
    platformBinding: 'Platform Binding',
    active: 'Active',
    inactive: 'Inactive',
    noInfo: 'No Info',
    bound: 'Bound {{count}}/4 platforms',
    excellent: 'Excellent',
    good: 'Good',
    few: 'Few',
    unbound: 'Unbound',
    noPlatformsBound: 'No platforms bound',
    
    // Twitch数据
    twitchData: 'Twitch Data',
    twitchUsername: 'Twitch Username',
    totalFollowers: 'Total Followers',
    accv30: '30-day ACCV',
    accv60: '60-day ACCV',
    accv90: '90-day ACCV',
    fanConversionRate: 'Fan Conversion Rate',
    lastUpdated: 'Last Updated',
    conversionRateDesc: '30-day average viewers ÷ total followers',
    noTwitchInfo: 'No Twitch Information',
    
    // 游戏标签概览
    gameTagsOverview: 'Game Tags Overview',
    gameGenres: 'Game Genres',
    gameThemes: 'Game Themes',
    highestWeightTag: 'Highest Weight Tag',
    dataRange: 'Data Range',
    avgMatchRate: 'Average Match Rate',
    
    // 数据趋势
    accvTimeTrend: 'ACCV Time Trend',
    accvTrendDesc: 'Comparison of average concurrent viewers across different time ranges',
    viewerDataAnalysis: 'Viewer Data Analysis',
    viewerAnalysisDesc: 'Analysis of follower base and viewer activity',
    currentFollowers: 'Current Followers',
    avgViewers30Day: '30-day Viewers',
    conversionRate: 'Conversion Rate',
    dataInterpretation: 'Data Interpretation:',
    conversionRateFormula: '• Conversion Rate = 30-day average viewers ÷ total followers × 100%',
    conversionRateIndicator: '• Higher conversion rate indicates better follower engagement',
    viewerTrendDesc: '• Viewer trend reflects streaming performance across different periods',
    conversionRateEvaluation: 'Conversion Rate Evaluation',
    excellentConversion: '✅ Excellent conversion rate',
    goodConversion: '⚠️ Good conversion rate',
    lowConversion: '❌ Low conversion rate',
    
    // 趋势分析
    trendAnalysis: 'Trend Analysis',
    continuousUptrend: '📈 Continuous upward trend, excellent performance',
    continuousDowntrend: '📉 Continuous downward trend, needs attention',
    recentImprovement: '📊 Recent performance improvement, promising',
    recentDecline: '📊 Recent performance decline, suggest optimization',
    relativelyStable: '📊 Relatively stable performance',
    
    // 主播评价概览
    streamerRatingOverview: 'Streamer Rating Overview',
    activityRating: 'Activity Rating',
    executionRating: 'Execution Rating',
    costEffectRating: 'Cost-Effect Rating',
    
    // 游戏标签页面
    tagStatsOverview: 'Tag Statistics Overview',
    gameGenres: 'Game Genres',
    gameThemes: 'Game Themes',
    totalWeight: 'Total Weight',
    avgMatchRate: 'Average Match Rate',
    gameGenreDistribution: 'Game Genre Distribution',
    gameThemeDistribution: 'Game Theme Distribution',
    tags: 'tags',
    genreTagDetails: 'Genre Tag Details',
    themeTagDetails: 'Theme Tag Details',
    weight: 'Weight',
    match: 'Match',
    tagWeightRanking: 'Tag Weight Ranking',
    top: 'Top',
    topN: 'Top {{count}}',
    noTagData: 'No tag data available',
    expand: 'Expand',
    collapse: 'Collapse',
    
    // 游戏列表
    gameList: 'Game List',
    games: 'games',
    gameName: 'Game Name',
    playTime: 'Play Time',
    releaseTime: 'Release Time',
    dataSyncTime: 'Data Sync Time',
    clickToVisitIGDB: 'Click to visit IGDB game page',
    noGameData: 'No game data available',
    noGameRecords: 'This user has no game records in {{days}} days',
    
    // 游戏统计
    gameStatsOverview: 'Game Statistics Overview',
    totalGames: 'Total Games',
    totalPlayTime: 'Total Play Time',
    avgPlayTime: 'Average Play Time',
    recentNewGames: 'Recent New Games',
    
    // 历史趋势页面
    historicalTrendAnalysis: 'Historical Trend Analysis',
    historicalTrendDesc: 'Display user\'s ACCV data comparison across different time periods to understand performance trends.',
    accvDataOverview: 'ACCV Data Overview',
    dayAverage: '{{days}}-day average',
    audienceFollowerData: 'Audience & Follower Data',
    dataExplanation: 'Data Explanation',
    accvTimeComparison: 'ACCV Time Period Comparison',
    dataDetails: 'Data Details',
    timeRange: 'Time Range',
    relativeChange: 'Relative Change',
    dataStatus: 'Data Status',
    baseline: 'Baseline',
    hasData: 'Has Data',
    noData: 'No Data',
    dataNote: 'Data Note',
    dataNote1: '• ACCV (Average Concurrent Viewers): Average concurrent viewer count, reflects streamer\'s influence',
    dataNote2: '• Currently system records 30-day, 60-day, 90-day ACCV data',
    dataNote3: '• Fan conversion rate = 30-day average viewers ÷ total followers, higher value indicates better fan engagement',
    dataNote4: '• Relative change uses 30-day data as baseline, positive values indicate better historical performance, negative values indicate recent improvement',
    
    // 时间格式
    minutes: 'minutes',
    hours: 'hours',
    days: 'days',
    unknown: 'Unknown',
    notSynced: 'Not Synced',
    
    // 数字格式
    thousandAbbrev: 'K',
    millionAbbrev: 'M',
    billionAbbrev: 'B',
  },
  zh: {
    // 筛选相关
    timeRange: '时间范围：',
    game: '游戏：',
    allGames: '全部游戏',
    sort: '排序：',
    search: '搜索：',
    searchPlaceholder: '搜索用户名或Twitch用户名...',
    more: '更多',
    gameTags: '游戏标签',
    gameType: '游戏类型：',
    gameTheme: '游戏主题：',
    addType: '添加类型',
    addTheme: '添加主题',

    // 用户列表相关
    userList: '用户列表 ({{count}} 个用户)',
    selectedUsers: '- 已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    addToPackage: '添加到主播包',
    clearSelection: '清除选择',

    // 排序选项
    matchScore: '匹配度',
    activityLevel: '活跃度',
    executionAbility: '执行力',
    costEffectiveness: '性价比',
    followers: '粉丝数',
    avgViewers: '平均观众',

    // 主播类型
    unlimited: '不限',
    premiumStreamer: '优质主播',
    potentialStreamer: '潜力主播',
    normalStreamer: '普通主播',
    otherStreamers: '其他主播',

    // 数据加载成功提示
    loadedStreamersSuccess: '成功加载了{{count}}个主播',
    loadedStreamerSuccess: '成功加载了{{count}}个主播',
    loadDataFailed: '加载数据失败',
    networkRequestFailed: '网络请求失败',

    // 评价标签
    activity: '活跃度',
    execution: '执行力',
    costEffect: '性价比',
    noRating: '无评价',

    // 消息
    loadingUsers: '正在加载用户数据...',
    noUsers: '没有找到匹配的用户',
    addedToSelection: '已添加当前页面的 {{count}} 个用户到选择列表',
    clearedSelection: '已取消选择 {{count}} 个用户',

    // 语言相关
    languageSettings: '语言设置',
    interfaceLanguage: '界面语言',
    contentLanguage: '内容语言',
    autoDetect: '自动检测',

    // 添加对应的中文翻译
    language: '语言',
    streamerFilterSystem: '主播包筛选系统',
    streamerGroupManagement: '主播包分组管理',
    streamerPackageSystem: '主播包管理系统',
    groupList: '分组列表',
    addGroup: '添加分组',
    loadingGroups: '正在加载分组...',
    noGroups: '暂无分组数据',
    memberCount: '{{count}} 个成员',
    edit: '编辑',
    delete: '删除',
    days: '天',
    tags: '标签',
    noTags: '无标签',
    search: '搜索',
    rowsPerPage: '每页行数:',
    displayedRows: '{{from}}-{{to}} / 共 {{count}}',
    close: '关闭',
    current: '当前',

    // 添加对应的中文翻译
    totalGames: '游戏总数',
    totalGroups: '分组总数',
    totalPackages: '包总数',
    totalStreamers: '主播总数',
    existingGroups: '现有分组 ({{count}} 个)',
    streamers: '主播',
    packages: '主播包',
    viewExpectedData: '查看预期数据',
    sendTaskInvitation: '发送任务邀约',
    viewDays: '查看天数:',
    switchingToPackage: '正在切换到"{{name}}"...',
    loadingStreamerData: '正在加载主播数据...',
    streamerList: '主播列表 ({{count}} 个主播)',
    selected: '已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    transferToOtherPackage: '转移到其他包 ({{count}})',
    deleteSelected: '删除选中 ({{count}})',
    clearSelection: '清除选择',
    selectedStreamers: '选中的主播：',
    noOtherPackagesAvailable: '⚠️ 当前分组没有其他可用的主播包，无法进行转移操作',
    noStreamers: '暂无主播',
    noStreamersInPackage: '此主播包暂时没有添加任何主播',
    pleaseSelectGroupAndPackage: '请选择分组和主播包',
    selectGroupAndPackageToView: '选择左侧的分组和主播包来查看主播列表',
    packageNotExists: '主播包不存在',
    currentSelectedPackageInvalid: '当前选择的主播包索引无效',
    searchGroups: '搜索分组...',
    groupManagementHome: '分组管理首页',
    refreshing: '刷新中...',
    noMatchingGroups: '未找到匹配的分组',
    noGroupData: '暂无分组数据',
    createPackage: '创建包',
    editPackage: '编辑包',
    deletePackage: '删除包',
    confirmDeletePackage: '确认删除主播包',
    confirmDeletePackageMessage: '确定要删除主播包 "{{name}}" 吗？',
    cannotUndoOperation: '⚠️ 此操作不可撤销，包中的所有主播数据将被清除',
    deleting: '删除中...',
    confirmDelete: '确认删除',
    autoGenerateDefaultGroups: '自动生成默认分组',
    packageBasicInfo: '基本信息',
    packageName: '包名称',
    enterPackageName: '请输入主播包名称...',
    packageDescription: '包描述',
    enterPackageDescription: '请输入主播包描述...',
    packageSettings: '包设置',
    maxStreamers: '最大主播数',
    priority: '优先级',
    higherNumberHigherPriority: '数值越大优先级越高',
    visibilityLevel: '可见性级别',
    tags: '标签',
    enterTagsCommaSeparated: '输入标签，用逗号分隔',
    tagsExample: '例如: 优质, 热门, 新手',
    streamerManagement: '主播管理',
    currentlySelected: '当前选择了 {{count}} 个主播',
    streamerListAutoGenerated: '* 主播列表将根据包的设置和筛选条件自动生成',
    packageStats: '包统计信息:',
    actualStreamers: '实际主播数: {{count}}',
    averageViewers: '平均观众数: {{count}}',
    totalFollowers: '总粉丝数: {{count}}',
    calculationPeriod: '统计周期: {{period}}',
    processing: '处理中...',
    create: '创建',
    update: '更新',
    public: '公开',
    private: '私有',
    restricted: '受限',
    transferUsersToOtherPackage: '转移用户到其他主播包',
    transferInfo: '转移信息',
    gameGroup: '游戏分组：',
    currentPackage: '当前主播包：',
    selectedUsersCount: '选中用户数：',
    selectTargetPackage: '选择目标主播包',
    transferInstructions: '转移说明:',
    transferInstruction1: '• 用户将从当前主播包中移除，并添加到目标主播包',
    transferInstruction2: '• 转移操作不可撤销，请确认选择正确的目标包',
    transferInstruction3: '• 转移完成后会自动刷新数据',
    confirmTransfer: '确认转移',
    transferring: '转移中...',
    noActiveQuests: '暂无活跃任务',
    noActiveQuestsForGame: '当前游戏没有可用的活跃任务',
    loadingActiveQuests: '正在加载活跃任务...',
    sendTaskInvitationTo: '即将发送给 {{count}} 个主播：',
    selectTasksToSend: '选择要发送的任务',
    totalTasks: '共 {{total}} 个任务，已选择 {{selected}} 个',
    selectAllTasks: '全选任务',
    deselectAllTasks: '取消全选',
    taskOverview: '任务概览',
    totalTasksCount: '总任务',
    selectedTasks: '已选择',
    streamingTasks: '直播任务',
    creationTasks: '二创任务',
    urgentTasks: '紧急任务',
    startTime: '开始时间',
    endTime: '结束时间',
    taskType: '任务类型',
    requiredStreamTime: '直播时长要求',
    notSet: '未设置',
    noRequirement: '无要求',
    streamingTask: '直播任务',
    creationTask: '二创任务',
    contentCreation: '内容创作',
    promotionTask: '推广任务',
    eventTask: '活动任务',
    unknownType: '未知类型',
    urgent: '紧急',
    minimumViewers: '最低观众: {{count}}',
    rewards: '奖励:',
    sendPreview: '发送预览：',
    willSendInvitationEmail: '将向 {{userCount}} 个主播发送包含 {{taskCount}} 个任务的邀约邮件',
    selectedTasksList: '选中的任务：',
    sendInvitation: '发送邀约 ({{userCount}} 个主播)',
    sending: '发送中...',
    minutes: '分钟',
    hours: '小时',
    days: '天',
    unknownUser: '未知用户',
    expectedDataStats: '预期数据统计',
    statsOverview: '统计概览',
    group: '分组：',
    package: '主播包：',
    statsPeriod: '统计周期：',
    calculationTime: '计算时间：',
    streamersCount: '主播数量',
    averageCCV: '平均观众数',
    peakCCV: '峰值观众数',
    totalFollowersCount: '总粉丝数',
    detailedStats: '详细统计数据',
    streamingTimeStats: '直播时间统计',
    totalStreamingTime: '累计直播时间:',
    avgStreamingTimePerStreamer: '人均直播时间:',
    viewingDataStats: '观看数据统计',
    totalViewingTime: '累计观看时间:',
    vodViews: 'VOD观看次数:',
    dataExplanation: '数据说明:',
    dataNote1: '• 以上数据基于所选主播在近{{days}}天的历史表现进行计算和预测',
    dataNote2: '• 平均观众数(Average CCV)基于主播的ACCV数据计算',
    dataNote3: '• 峰值观众数、观看时间等指标基于历史数据和算法模型预测',
    dataNote4: '• 实际数据可能因主播表现、游戏热度等因素有所差异',
    calculatingExpectedData: '正在计算预期数据...',
    basedOnRecentDaysData: '基于近{{days}}天的主播数据进行分析',
    dataCalculationFailed: '数据计算失败',
    retryOrContactSupport: '请重试或联系技术支持',
    refreshData: '刷新数据',
    // 新增翻译
    autoGenerateComplete: '自动生成完成：创建了 {{groups}} 个分组和 {{packages}} 个主播包',
    noNewGroupsOrPackages: '没有需要创建的新分组或主播包',
    autoGenerationFailed: '自动生成失败: {{error}}',
    processingAutoGeneration: '正在自动生成分组和主播包...',
    thisOperationWillCreate: '此操作将为所有符合条件的游戏自动创建默认分组和默认主播包。',
    onlyCreateForGamesWithoutDefault: '• 只会为没有默认分组的游戏创建新分组',
    onlyCreateForGroupsWithoutDefault: '• 只会为没有默认主播包的分组创建新主播包',
    onlyProcessActiveGamesWithTwitch: '• 只处理状态为"active"且有nameInTwitch的游戏',
    operationCannotBeUndone: '⚠️ 此操作不可撤销，请谨慎操作',
    generating: '生成中...',
    autoGeneratingGroupsAndPackages: '正在自动生成分组和主播包...',
    thisCouldTakeMinutes: '请稍候，这可能需要几分钟时间',
    generationResults: '生成结果',
    processedGames: '处理的游戏数量:',
    createdGroups: '创建的分组数量:',
    createdPackages: '创建的主播包数量:',
    successfullyProcessed: '成功处理:',
    failedProcessed: '处理失败:',
    successRate: '成功率: {{rate}}',
    operator: '操作者: {{username}}',
    startGeneration: '开始生成',
    completed: '完成',
    //----------- 主播包补充翻译的-------------
    // 时间范围
    '30days': '30天',
    '60days': '60天',
    '90days': '90天', 
    '120days': '120天',
    '365days': '365天',
    'days': '天',

    // 筛选相关
    timeRange: '时间范围：',
    game: '游戏：',
    allGames: '全部游戏',
    sort: '排序：',
    search: '搜索：',
    searchPlaceholder: '搜索用户名或Twitch用户名...',
    more: '更多',
    gameTags: '游戏标签',
    gameType: '游戏类型：',
    gameTheme: '游戏主题：',
    addType: '添加类型',
    addTheme: '添加主题',

    // 排序选项
    matchScore: '匹配度',
    activityLevel: '活跃度',
    executionAbility: '执行力',
    costEffectiveness: '性价比',
    followers: '粉丝数',
    avgViewers: '平均观众',

    // 主播类型
    streamerType: '主播类型：',
    unlimited: '不限',
    premiumStreamer: '优质主播',
    potentialStreamer: '潜力主播',
    normalStreamer: '普通主播',
    otherStreamers: '其他主播',

    // 卡片内容
    followersLabel: '粉丝',
    activity: '活跃度',
    execution: '执行力',
    costEffect: '性价比',
    matchDegree: '匹配度',
    noRating: '无评价',

    // 搜索按钮
    searchBtn: '搜索',

    // More 菜单项
    syncStreamerRatings: '同步主播评价标签',
    syncGameTags: '同步游戏标签',
    syncGameInfo: '同步游戏信息',

    // 弹窗内容 - 主播评价体系管理
    streamerRatingSystemManagement: '主播评价体系管理',
    syncTags: '同步标签',
    systemConfig: '系统配置',
    syncStreamerRatingTags: '同步主播评价标签',
    syncAllStreamerRatingDesc: '同步所有主播的评价标签数据，包括活跃度、完成能力和成本效益等评价指标。',
    currentConfigOverview: '当前配置概览',
    tagTypesCount: '标签类型总数',
    activeTagsCount: '活跃标签数',
    totalTagsCount: '总标签数',
    tagTypesOverview: '标签类型概览',
    noConfigData: '暂无配置数据',
    syncOptionSettings: '同步选项设置',
    forceUpdateAllUsers: '强制更新所有用户',
    forceUpdateDesc: '勾选后将强制更新所有主播的评价标签，包括已有评价的用户。不勾选时将跳过已有评价的用户，只更新新用户或评价缺失的用户。',
    startSyncTags: '开始同步标签',
    viewDetailedConfig: '查看详细配置',
    forceUpdateMode: '强制更新模式：将重新计算所有主播的评价标签，这个过程可能需要较长时间。',
    smartUpdateMode: '智能更新模式：只更新新用户或评价缺失的用户，可以节省时间。',
    tagTypeConfig: '标签类型配置',
    cancel: '取消',
    save: '保存',
    saving: '保存中...',
    saveTypeConfig: '保存类型配置',
    editTypeConfig: '编辑类型配置',
    typeCode: '类型编码',
    typeName: '类型名称',
    defaultStatDays: '默认统计天数',
    description: '说明',
    noTagTypeData: '暂无标签类型数据',
    tagDetailedConfig: '标签详细配置',
    saveTagConfig: '保存标签配置',
    editTagConfig: '编辑标签配置',
    initializeSystem: '初始化系统',
    initializing: '初始化中...',
    tagCode: '标签编码',
    tagName: '标签名称',
    category: '分类',
    registrationTime: '注册时间',
    recentApplicationDays: '申请统计天数',
    applicationRatio: '申请比例',
    recentCompletionDays: '完成统计天数',
    completionRatio: '完成比例',
    completionRateRatio: '完成率比例',
    rewardRatio: '报酬比例',
    priority: '优先级',
    status: '状态',
    enabled: '启用',
    disabled: '禁用',
    noTagConfigData: '暂无标签配置数据',
    editInstructions: '编辑说明：',
    editInstructionsDesc: '• 标签类型配置：可编辑默认统计天数和说明\n• 标签详细配置：可编辑标签名称和注册时间区间\n• 110-150标签：可编辑申请比例区间\n• 210-250标签：可编辑完成比例和完成率比例区间\n• 310-350标签：可编辑完成率比例和报酬比例区间',

    // 弹窗内容 - 游戏标签同步
    syncGameTagsTitle: '同步游戏标签',
    selectGameTagTimeRange: '选择要同步的游戏标签时间范围，系统将重新计算选中时间范围内的用户游戏偏好标签。',
    updateAllTimeRanges: '更新所有时间范围',
    updateAllTimeRangesDesc: '勾选后将更新所有时间范围（30、60、90、120、365天）的标签，忽略下方的具体选择。',
    selectGameTagRanges: '选择游戏标签范围（可多选）：',
    allRangesSelected: '已选择更新所有范围，下方选择将被忽略',
    pleaseSelectAtLeastOne: '请至少选择一个时间范围',
    willUpdateAllRanges: '将更新所有时间范围（30、60、90、120、365天）的标签',
    selectedRanges: '已选择 {{count}} 个时间范围: {{ranges}}天',
    syncLatestData: '同步最新数据',
    syncLatestDataDesc: '如勾选，将从数据源获取最新游戏数据后重新计算标签。取消勾选仅基于现有数据重新计算标签，不更新游戏数据。',
    syncProcessDesc: '同步过程可能需要几分钟时间，时间取决于用户数量和所选范围。',
    updateAllRangesTakeLonger: '更新所有范围可能需要更长时间。',
    startSync: '开始同步',
    syncing: '同步中...',

    // 弹窗内容 - 游戏信息同步
    gameIGDBInfoSync: '游戏IGDB信息同步',
    syncConfig: '同步配置',
    selectGameSource: '选择游戏来源',
    allGames: '所有游戏',
    noizPlatformGames: 'Noiz平台游戏',
    nonNoizPlatformGames: '非Noiz平台游戏',
    allGamesDesc: '从UserGame表获取所有游戏数据',
    noizGamesDesc: '从Game表获取平台认证的游戏',
    nonNoizGamesDesc: '排除平台游戏的其他游戏',
    statDays: '统计天数',
    syncMode: '同步模式',
    smartSync: '智能同步（仅未同步）',
    forceSync: '强制同步（仅已同步）',
    fullSync: '全量同步（所有游戏）',
    searchGames: '搜索游戏...',
    searchGame: '搜索游戏',
    statsOverview: '统计概览',
    loadingData: '正在加载数据...',
    totalGamesCount: '总游戏数',
    synced: '已同步',
    unsynced: '未同步',
    syncRate: '同步率',
    gameList: '游戏列表',
    selectAll: '全选',
    deselectAll: '取消全选',
    selectedCount: '已选择 {{count}} 个',
    gameListEmpty: '没有找到匹配的游戏',
    loadingGameData: '正在加载游戏数据...',
    noGameData: '没有找到游戏',
    operationInstructions: '操作说明',
    operationInstructionsDesc: '• 选择游戏后点击"开始同步"，未选择则同步所有符合条件的游戏\n• 智能同步：跳过已有IGDB信息的游戏\n• 强制同步：重新获取已有IGDB信息的游戏\n• 全量同步：处理所有游戏，根据现有状态决定是否覆盖',
    syncInProgress: '同步中...',
    syncIGDBInfo: '开始同步',
    currentProcessing: '当前: {{game}}',
    progress: '进度: {{processed}}/{{total}}',

    // 用户列表相关
    userList: '用户列表 ({{count}} 个用户)',
    selectedUsers: '- 已选择 {{count}} 个',
    oneClickSelect: '一键选择',
    addToPackage: '添加到主播包',
    clearSelection: '清除选择',

    // 消息
    loadingUsers: '正在加载用户数据...',
    noUsers: '没有找到匹配的用户',
    addedToSelection: '已添加当前页面的 {{count}} 个用户到选择列表',
    clearedSelection: '已取消选择 {{count}} 个用户',

    // 语言相关
    languageSettings: '语言设置',
    interfaceLanguage: '界面语言',
    contentLanguage: '内容语言',
    autoDetect: '自动检测',

    // 只添加真正缺失的翻译
    addToStreamerPackage: '添加到主播包',
    selectedUsersCount: '已选择 {{count}} 个用户',
    selectedUsersList: '选中用户列表：',
    typeDistribution: '类型分布：',
    selectionPersistence: '选择持久化：用户选择会在翻页、筛选时保持，可手动点击标签删除图标移除单个用户',
    clickToAddToPackage: '点击"添加到主播包"可将选中的用户批量添加到指定的游戏主播包中',
    
    currentFilters: '当前筛选条件',
    clearAllFilters: '清除所有筛选',
    filterPersistence: '筛选结果将在翻页时保持',
    
    match: '匹配度',
    viewStats: '查看统计',
    
    // 主播包弹窗相关
    addUsersToStreamerPackage: '添加用户到主播包',
    aboutToAdd: '即将添加 {{count}} 个用户到主播包：',
    searchAndSelectGameGroup: '1. 搜索并选择游戏分组',
    enterGameNameToSearch: '输入游戏名称进行搜索...',
    selectedGame: '已选择游戏：',
    defaultGroup: '默认分组: {{groupName}}',
    autoSelectedDefaultGroup: '已自动选择默认分组，找到 {{count}} 个可用主播包',
    selectStreamerPackage: '2. 选择主播包',
    pleaseSelectGameFirst: '请先选择游戏',
    gameHasNoDefaultGroup: '该游戏没有默认分组',
    selectStreamerPackageOption: '选择主播包',
    noAvailablePackages: '该分组暂无可用主播包',
    addPreview: '添加预览：',
    willAddUsersToPackage: '将向"{{packageName}}"主播包添加 {{userCount}} 个用户',
    packageCurrently: '主播包当前有 {{current}} 个主播，添加后将有 {{total}} 个（限制：{{max}}）',
    operationDescription: '操作说明：选择游戏后会自动选择该游戏的默认分组，然后您可以选择分组下的主播包',
    adding: '添加中...',
    addUsers: '添加 {{count}} 个用户',
    
    // IGDB同步进度相关
    syncingIGDBInfo: '正在同步IGDB信息...',
    currentProcessing: '当前处理: {{game}}',
    
    // 用户相关
    noRatingData: '无评价数据',
    unknownUser: '未知用户',
    
    // 数据相关
    gameCount: '{{count}} 个游戏',
    tagCount: '{{count}} 个标签',
    userCount: '{{count}} 个用户',
    items: '项',

    // 添加平台用户相关翻译
    platformUsers: '平台用户',
    platformUsersDesc: '经过平台验证和管理的用户',
    onlyShowPlatformUsers: '只显示平台用户',
    allUsers: '全部用户',
    // 平台用户筛选
    // 数据加载页面
    loadingStreamerGroupData: '正在加载主播分组数据...',
    loadingLatestGroupInfo: '请稍候，正在获取最新的分组和主播信息',

    // 左侧栏
    streamers: '主播',
    streamer: '主播',
    streamersCount: '{{count}} 个主播',
    streamerCount: '{{count}} 个主播',

    // 自动生成相关
    autoGenerateDefaultGroups: '自动生成默认分组',
    autoGenerateDefaultGroupsAndPackages: '自动生成默认分组和主播包',
    thisOperationWillCreate: '此操作将为所有符合条件的游戏自动创建默认分组和默认主播包。',
    onlyCreateForGamesWithoutDefault: '• 只会为没有默认分组的游戏创建新分组',
    onlyCreateForGroupsWithoutDefault: '• 只会为没有默认主播包的分组创建新主播包',
    onlyProcessActiveGamesWithTwitch: '• 只处理状态为"active"且有nameInTwitch的游戏',
    operationCannotBeUndone: '⚠️ 此操作不可撤销，请谨慎操作',
    cancel: '取消',
    startGeneration: '开始生成',
    generating: '生成中...',
    autoGeneratingGroupsAndPackages: '正在自动生成分组和主播包...',
    thisCouldTakeMinutes: '请稍候，这可能需要几分钟时间',
    
    // 生成结果
    generationResults: '生成结果',
    processedGames: '处理的游戏数量:',
    createdGroups: '创建的分组数量:',
    createdPackages: '创建的主播包数量:',
    successfullyProcessed: '成功处理:',
    failedProcessed: '处理失败:',
    successRate: '成功率: {{rate}}',
    operator: '操作者: {{username}}',
    completed: '完成',

    // 主播包相关
    packageBasicInfo: '基本信息',
    packageName: '包名称',
    enterPackageName: '请输入主播包名称...',
    packageDescription: '包描述',
    enterPackageDescription: '请输入主播包描述...',
    packageSettings: '包设置',
    maxStreamers: '最大主播数',
    priority: '优先级',
    higherNumberHigherPriority: '数值越大优先级越高',
    visibilityLevel: '可见性级别',
    tags: '标签',
    enterTagsCommaSeparated: '输入标签，用逗号分隔',
    tagsExample: '例如: 优质, 热门, 新手',
    streamerManagement: '主播管理',
    currentlySelected: '当前选择了 {{count}} 个主播',
    streamerListAutoGenerated: '* 主播列表将根据包的设置和筛选条件自动生成',

    // 删除确认
    confirmDeletePackage: '确认删除主播包',
    confirmDeletePackageMessage: '确定要删除主播包 "{{name}}" 吗？',
    cannotUndoOperation: '⚠️ 此操作不可撤销，包中的所有主播数据将被清除',
    deleting: '删除中...',
    confirmDelete: '确认删除',

    // 其他状态文本
    processing: '处理中...',
    public: '公开',
    private: '私有',
    restricted: '受限',
    create: '创建',
    update: '更新',
    refreshing: '刷新中...',

    // 游戏标签同步相关
    syncGameTagsDesc: '基于数据库中的现有数据重新计算和同步用户的游戏标签',
    syncCurrentDataDesc: '基于数据库现有数据进行标签计算，无需重新获取外部数据',
    syncProcessTimeDesc: '同步时间取决于用户数量和选择的时间范围',
    syncProcessNote: '同步说明',
    pleaseSelectAtLeastOneRange: '请至少选择一个时间范围或勾选"更新所有范围"',
    atLeastOneRangeRequired: '至少需要选择一个时间范围',
    syncSuccess: '同步成功！处理了 {{count}} 个用户，用时 {{time}} 秒',
    syncGameTagsFailed: '同步游戏标签失败',
    syncUserGameTagsFailed: '同步用户游戏标签失败',
    selectTimeRangeForTagUpdate: '请选择需要更新的时间范围标签，点击"同步"按钮开始更新用户游戏标签数据',
    selectUpdateRanges: '选择要更新的标签范围',
    canSelectMultipleRanges: '可多选，将重新计算选中时间范围的用户游戏标签',
    // Twitch 相关翻译
    openTwitchPage: '打开 Twitch 页面',
    openSullyGnomeDataPage: '打开 SullyGnome 数据页面',
    visitTwitchPage: '点击访问 {{username}} 的 Twitch 页面',
    noTwitchInfo: '无 Twitch 信息',
    
    // 统计弹窗相关翻译
    userStatistics: '用户统计',
    basicInfo: '基本信息',
    gamePreferences: '游戏偏好',
    accountInfo: '账户信息',
    username: '用户名',
    displayName: '显示名称',
    registrationDate: '注册日期',
    lastActive: '最后活跃',
    accountType: '账户类型',
    verificationStatus: '验证状态',
    verified: '已验证',
    unverified: '未验证',
    
    // Twitch 信息
    twitchInfo: 'Twitch 信息',
    twitchUsername: 'Twitch 用户名',
    twitchFollowers: 'Twitch 粉丝',
    twitchViews: '总观看次数',
    twitchCreatedAt: 'Twitch 创建时间',
    averageViewers: '平均观众',
    peakViewers: '峰值观众',
    
    // 游戏标签
    gameTagsWeights: '游戏标签权重',
    genreTags: '类型标签',
    themeTags: '主题标签',
    tagWeight: '权重',
    noGameTags: '暂无游戏标签',
    
    // 主播评价
    streamerRatings: '主播评价',
    activityRating: '活跃度评价',
    completionRating: '完成度评价',
    costEffectivenessRating: '性价比评价',
    ratingCode: '评价代码',
    ratingDescription: '说明',
    lastUpdated: '最后更新',
    noRatingsAvailable: '暂无评价数据',
    
    // 统计数据
    statisticsData: '统计数据',
    accvHistory: 'ACCV 历史 (近30天)',
    followerGrowth: '粉丝增长趋势',
    viewersCount: '观众数',
    followersCount: '粉丝数',
    day: '天',
    date: '日期',
    
    // 数据状态
    dataNotAvailable: '数据不可用',
    loadingData: '正在加载数据...',
    noDataToDisplay: '暂无数据显示',
    
    // 匹配度相关
    matchAnalysis: '匹配度分析',
    matchScore: '匹配度',
    matchFactors: '匹配因子',
    
    // 操作按钮
    refreshData: '刷新数据',
    exportData: '导出数据',
    viewDetails: '查看详情',
    
    // 时间格式
    timeAgo: '{{time}}前',
    justNow: '刚刚',
    minutesAgo: '{{minutes}}分钟前',
    hoursAgo: '{{hours}}小时前',
    daysAgo: '{{days}}天前',
    monthsAgo: '{{months}}个月前',
    yearsAgo: '{{years}}年前',
    
    // 统计弹窗相关翻译
    userStatistics: '用户统计',
    overview: '概览',
    gameTags: '游戏标签',
    historicalTrend: '历史趋势',
    
    // 概览页面
    userOverview: '用户概览',
    daysData: '{{days}}天数据',
    matchScore: '匹配度评分',
    totalFollowers: '总粉丝数',
    avgViewers30: '30日平均观众',
    totalGameTags: '游戏标签总数',
    
    // 用户信息
    userInfo: '用户信息',
    username: '用户名',
    registrationTime: '注册时间',
    userStatus: '用户状态',
    region: '所在地区',
    lastLogin: '最近登录',
    languagePreference: '语言偏好',
    platformBinding: '平台绑定',
    active: '活跃',
    inactive: '非活跃',
    noInfo: '暂无信息',
    bound: '已绑定 {{count}}/4 个平台',
    excellent: '优秀',
    good: '良好',
    few: '较少',
    unbound: '未绑定',
    noPlatformsBound: '未绑定任何平台',
    
    // Twitch数据
    twitchData: 'Twitch 数据',
    twitchUsername: 'Twitch 用户名',
    totalFollowers: '总粉丝数',
    accv30: '30日ACCV',
    accv60: '60日ACCV',
    accv90: '90日ACCV',
    fanConversionRate: '粉丝转化率',
    lastUpdated: '最近更新',
    conversionRateDesc: '30日平均观众数 ÷ 总粉丝数',
    noTwitchInfo: '无 Twitch 信息',
    
    // 游戏标签概览
    gameTagsOverview: '游戏标签概览',
    gameGenres: '游戏类型',
    gameThemes: '游戏主题',
    highestWeightTag: '最高权重标签',
    dataRange: '数据范围',
    avgMatchRate: '平均匹配度',
    
    // 数据趋势
    accvTimeTrend: 'ACCV 时间趋势',
    accvTrendDesc: '不同时间范围的平均并发观众数对比',
    viewerDataAnalysis: '观众数据分析',
    viewerAnalysisDesc: '粉丝基数与观众活跃度分析',
    currentFollowers: '当前粉丝数',
    avgViewers30Day: '30日观众',
    conversionRate: '转化率',
    dataInterpretation: '数据解读:',
    conversionRateFormula: '• 转化率 = 30日平均观众数 ÷ 总粉丝数 × 100%',
    conversionRateIndicator: '• 转化率越高说明粉丝活跃度越好',
    viewerTrendDesc: '• 观众趋势反映了不同时期的直播表现',
    conversionRateEvaluation: '转化率评估',
    excellentConversion: '✅ 转化率优秀',
    goodConversion: '⚠️ 转化率良好',
    lowConversion: '❌ 转化率较低',
    
    // 趋势分析
    trendAnalysis: '趋势分析',
    continuousUptrend: '📈 持续上升趋势，表现优异',
    continuousDowntrend: '📉 持续下降趋势，需要关注',
    recentImprovement: '📊 近期表现回升，值得期待',
    recentDecline: '📊 近期表现下滑，建议优化',
    relativelyStable: '📊 表现相对稳定',
    
    // 主播评价概览
    streamerRatingOverview: '主播评价概览',
    activityRating: '活跃度评价',
    executionRating: '执行力评价',
    costEffectRating: '性价比评价',
    
    // 游戏标签页面
    tagStatsOverview: '标签统计概览',
    gameGenres: '游戏类型',
    gameThemes: '游戏主题',
    totalWeight: '总权重',
    avgMatchRate: '平均匹配度',
    gameGenreDistribution: '游戏类型分布',
    gameThemeDistribution: '游戏主题分布',
    tags: '标签',
    genreTagDetails: '游戏类型标签详情',
    themeTagDetails: '游戏主题标签详情',
    weight: '权重',
    match: '匹配',
    tagWeightRanking: '标签权重排名',
    top: '前',
    topN: '前{{count}}名',
    noTagData: '暂无标签数据',
    expand: '展开',
    collapse: '收起',
    
    // 游戏列表
    gameList: '游戏列表',
    games: '个游戏',
    gameName: '游戏名称',
    playTime: '游戏时间',
    releaseTime: '发行时间',
    dataSyncTime: '数据同步时间',
    clickToVisitIGDB: '点击访问 IGDB 游戏页面',
    noGameData: '暂无游戏数据',
    noGameRecords: '该用户在 {{days}} 天内没有游戏记录',
    
    // 游戏统计
    gameStatsOverview: '游戏统计概览',
    totalGames: '总游戏数',
    totalPlayTime: '总游戏时间',
    avgPlayTime: '平均游戏时间',
    recentNewGames: '近一年新游戏',
    
    // 历史趋势页面
    historicalTrendAnalysis: '历史趋势分析',
    historicalTrendDesc: '展示用户在不同时间段的ACCV数据对比，帮助了解用户的表现趋势。',
    accvDataOverview: 'ACCV 数据概览',
    dayAverage: '{{days}}天平均',
    audienceFollowerData: '观众粉丝数据',
    dataExplanation: '数据说明',
    accvTimeComparison: 'ACCV 时间段对比',
    dataDetails: '数据详情',
    timeRange: '时间范围',
    relativeChange: '相对变化',
    dataStatus: '数据状态',
    baseline: '基准',
    hasData: '有数据',
    noData: '无数据',
    dataNote: '数据说明',
    dataNote1: '• ACCV (Average Concurrent Viewers): 平均并发观众数，反映主播的直播影响力',
    dataNote2: '• 目前系统记录30天、60天、90天的ACCV数据',
    dataNote3: '• 粉丝转化率 = 30天平均观众数 ÷ 总粉丝数，数值越高说明粉丝活跃度越高',
    dataNote4: '• 相对变化以30天数据为基准，正值表示历史表现更好，负值表示近期表现提升',
    
    // 时间格式
    minutes: '分钟',
    hours: '小时',
    days: '天',
    unknown: '未知',
    notSynced: '未同步',
    
    // 数字格式
    thousandAbbrev: '千',
    millionAbbrev: '万',
    billionAbbrev: '亿',
  },
  ja: {
    // 筛选相关
    timeRange: '時間範囲：',
    game: 'ゲーム：',
    allGames: '全てのゲーム',
    sort: 'ソート：',
    search: '検索：',
    searchPlaceholder: 'ユーザー名またはTwitchユーザー名を検索...',
    more: 'その他',
    loadingStreamerData: 'ストリーマーデータを読み込み中...',
    gameTags: 'ゲームタグ',
    gameType: 'ゲームタイプ：',
    gameTheme: 'ゲームテーマ：',
    addType: 'タイプ追加',
    addTheme: 'テーマ追加',

    // 用户列表相关
    userList: 'ユーザーリスト ({{count}} ユーザー)',
    selectedUsers: '- {{count}} ユーザー選択済み',
    oneClickSelect: 'ワンクリック選択',
    addToPackage: 'ストリーマーパッケージに追加',
    clearSelection: '選択をクリア',

    // 排序选项
    matchScore: 'マッチ度',
    activityLevel: 'アクティビティレベル',
    executionAbility: '実行能力',
    costEffectiveness: 'コストパフォーマンス',
    followers: 'フォロワー',
    avgViewers: '平均視聴者',

    // 主播类型
    unlimited: '制限なし',
    premiumStreamer: 'プレミアムストリーマー',
    potentialStreamer: 'ポテンシャルストリーマー',
    normalStreamer: '通常ストリーマー',
    otherStreamers: 'その他ストリーマー',

    // 评价标签
    activity: 'アクティビティ',
    execution: '実行',
    costEffect: 'コスト効果',
    noRating: '評価なし',

    // 消息
    loadingUsers: 'ユーザーデータを読み込み中...',
    noUsers: '一致するユーザーが見つかりません',
    addedToSelection: '現在のページから{{count}}ユーザーを選択リストに追加しました',
    clearedSelection: '{{count}}ユーザーの選択をクリアしました',

    // 语言相关
    languageSettings: '言語設定',
    interfaceLanguage: 'インターフェース言語',
    contentLanguage: 'コンテンツ言語',
    autoDetect: '自動検出',

    // 添加日文翻译
    language: '言語',
    streamerFilterSystem: 'ストリーマーフィルターシステム',
    streamerGroupManagement: 'ストリーマーグループ管理',
    streamerPackageSystem: 'ストリーマーパッケージ管理システム',
    groupList: 'グループリスト',
    addGroup: 'グループ追加',
    loadingGroups: 'グループを読み込み中...',
    noGroups: 'グループデータがありません',
    memberCount: '{{count}} メンバー',
    edit: '編集',
    delete: '削除',
    days: '日',
    tags: 'タグ',
    noTags: 'タグなし',
    search: '検索',
    rowsPerPage: 'ページあたりの行数:',
    displayedRows: '{{from}}-{{to}} / {{count}}',
    close: '閉じる',
    current: '現在',
    // 时间范围
    '30days': '30日',
    '60days': '60日',
    '90days': '90日',
    '120days': '120日', 
    '365days': '365日',
    'days': '日',

    // 筛选相关
    timeRange: '時間範囲：',
    game: 'ゲーム：',
    allGames: '全てのゲーム',
    sort: 'ソート：',
    search: '検索：',
    searchPlaceholder: 'ユーザー名またはTwitchユーザー名を検索...',
    more: 'その他',
    gameTags: 'ゲームタグ',
    gameType: 'ゲームタイプ：',
    gameTheme: 'ゲームテーマ：',
    addType: 'タイプ追加',
    addTheme: 'テーマ追加',

    // 排序选项
    matchScore: 'マッチ度',
    activityLevel: 'アクティビティレベル',
    executionAbility: '実行能力',
    costEffectiveness: 'コストパフォーマンス',
    followers: 'フォロワー',
    avgViewers: '平均視聴者',

    // 主播类型
    streamerType: 'ストリーマータイプ：',
    unlimited: '制限なし',
    premiumStreamer: 'プレミアムストリーマー',
    potentialStreamer: 'ポテンシャルストリーマー',
    normalStreamer: '通常ストリーマー',
    otherStreamers: 'その他ストリーマー',

    // 卡片内容
    followersLabel: 'フォロワー',
    activity: 'アクティビティ',
    execution: '実行',
    costEffect: 'コスト効果',
    matchDegree: 'マッチ度',
    noRating: '評価なし',

    // 搜索按钮
    searchBtn: '検索',

    // More 菜单项
    syncStreamerRatings: 'ストリーマー評価同期',
    syncGameTags: 'ゲームタグ同期',
    syncGameInfo: 'ゲーム情報同期',

    // 只添加真正缺失的翻译
    addToStreamerPackage: 'ストリーマーパッケージに追加',
    selectedUsersCount: '{{count}}ユーザー選択済み',
    currentFilters: '現在のフィルター',
    clearAllFilters: 'すべてのフィルターをクリア',
    match: 'マッチ度',
    viewStats: '統計を見る',
    noRatingData: '評価データなし',
    unknownUser: '不明なユーザー',
    items: 'アイテム',

    // 添加平台用户相关翻译
    platformUsers: 'プラットフォームユーザー',
    platformUsersDesc: 'プラットフォームで認証・管理されているユーザー',
    onlyShowPlatformUsers: 'プラットフォームユーザーのみ表示',
    allUsers: '全ユーザー',

    // 数据加载页面
    loadingStreamerGroupData: 'ストリーマーグループデータを読み込み中...',
    loadingLatestGroupInfo: 'しばらくお待ちください。最新のグループとストリーマー情報を取得しています',

    // 左侧栏
    streamers: 'ストリーマー',
    streamer: 'ストリーマー',
    streamersCount: '{{count}} ストリーマー',
    streamerCount: '{{count}} ストリーマー',

    // 自动生成相关
    autoGenerateDefaultGroups: 'デフォルトグループの自動生成',
    autoGenerateDefaultGroupsAndPackages: 'デフォルトグループとパッケージの自動生成',
    thisOperationWillCreate: 'この操作は、すべての対象ゲームに対してデフォルトグループとパッケージを自動作成します。',
    onlyCreateForGamesWithoutDefault: '• デフォルトグループのないゲームにのみ新規グループを作成',
    onlyCreateForGroupsWithoutDefault: '• デフォルトパッケージのないグループにのみ新規パッケージを作成',
    onlyProcessActiveGamesWithTwitch: '• ステータスが"active"でnameInTwitchを持つゲームのみ処理',
    operationCannotBeUndone: '⚠️ この操作は取り消せません。慎重に進めてください',
    cancel: 'キャンセル',
    startGeneration: '生成開始',
    generating: '生成中...',
    autoGeneratingGroupsAndPackages: 'グループとパッケージを自動生成中...',
    thisCouldTakeMinutes: 'しばらくお待ちください。数分かかる場合があります',
    
    // 生成结果
    generationResults: '生成結果',
    processedGames: '処理されたゲーム数:',
    createdGroups: '作成されたグループ数:',
    createdPackages: '作成されたパッケージ数:',
    successfullyProcessed: '正常処理:',
    failedProcessed: '処理失敗:',
    successRate: '成功率: {{rate}}',
    operator: 'オペレーター: {{username}}',
    completed: '完了',

    // 主播包相关
    packageBasicInfo: '基本情報',
    packageName: 'パッケージ名',
    enterPackageName: 'パッケージ名を入力してください...',
    packageDescription: 'パッケージ説明',
    enterPackageDescription: 'パッケージ説明を入力してください...',
    packageSettings: 'パッケージ設定',
    maxStreamers: '最大ストリーマー数',
    priority: '優先度',
    higherNumberHigherPriority: '数値が大きいほど優先度が高い',
    visibilityLevel: '可視性レベル',
    tags: 'タグ',
    enterTagsCommaSeparated: 'タグをカンマ区切りで入力',
    tagsExample: '例: プレミアム, 人気, 初心者',
    streamerManagement: 'ストリーマー管理',
    currentlySelected: '現在{{count}}ストリーマーが選択されています',
    streamerListAutoGenerated: '* ストリーマーリストはパッケージ設定とフィルター条件に基づいて自動生成されます',

    // 删除确认
    confirmDeletePackage: 'パッケージ削除の確認',
    confirmDeletePackageMessage: 'パッケージ "{{name}}" を削除してもよろしいですか？',
    cannotUndoOperation: '⚠️ この操作は取り消せません。パッケージ内のすべてのストリーマーデータがクリアされます',
    deleting: '削除中...',
    confirmDelete: '削除確認',

    // 其他状态文本
    processing: '処理中...',
    public: '公開',
    private: 'プライベート',
    restricted: '制限付き',
    create: '作成',
    update: '更新',
    refreshing: '更新中...',

    // 数据加载成功提示
    loadedStreamersSuccess: '{{count}}人のストリーマーを正常に読み込みました',
    loadedStreamerSuccess: '{{count}}人のストリーマーを正常に読み込みました',
    loadDataFailed: 'データの読み込みに失敗しました',
    networkRequestFailed: 'ネットワークリクエストが失敗しました',

    // Twitch 相関翻訳
    openTwitchPage: 'Twitchページを開く',
    openSullyGnomeDataPage: 'SullyGnomeデータページを開く',
    visitTwitchPage: '{{username}}のTwitchページにアクセス',
    noTwitchInfo: 'Twitch情報なし',
    
    // 統計ダイアログ関連翻訳
    userStatistics: 'ユーザー統計',
    basicInfo: '基本情報',
    gamePreferences: 'ゲーム設定',
    accountInfo: 'アカウント情報',
    username: 'ユーザー名',
    displayName: '表示名',
    registrationDate: '登録日',
    lastActive: '最終アクティブ',
    accountType: 'アカウント種別',
    verificationStatus: '認証状態',
    verified: '認証済み',
    unverified: '未認証',
    
    // Twitch 情報
    twitchInfo: 'Twitch情報',
    twitchUsername: 'Twitchユーザー名',
    twitchFollowers: 'Twitchフォロワー',
    twitchViews: '総視聴回数',
    twitchCreatedAt: 'Twitch作成日',
    averageViewers: '平均視聴者',
    peakViewers: 'ピーク視聴者',
    
    // ゲームタグ
    gameTagsWeights: 'ゲームタグ重み',
    genreTags: 'ジャンルタグ',
    themeTags: 'テーマタグ',
    tagWeight: '重み',
    noGameTags: 'ゲームタグがありません',
    
    // ストリーマー評価
    streamerRatings: 'ストリーマー評価',
    activityRating: 'アクティビティ評価',
    completionRating: '完了評価',
    costEffectivenessRating: 'コストパフォーマンス評価',
    ratingCode: '評価コード',
    ratingDescription: '説明',
    lastUpdated: '最終更新',
    noRatingsAvailable: '評価データがありません',
    
    // 統計データ
    statisticsData: '統計データ',
    accvHistory: 'ACCV履歴 (過去30日)',
    followerGrowth: 'フォロワー成長トレンド',
    viewersCount: '視聴者数',
    followersCount: 'フォロワー数',
    day: '日',
    date: '日付',
    
    // データ状態
    dataNotAvailable: 'データ利用不可',
    loadingData: 'データ読み込み中...',
    noDataToDisplay: '表示するデータがありません',
    
    // マッチ度関連
    matchAnalysis: 'マッチ度分析',
    matchScore: 'マッチ度',
    matchFactors: 'マッチ要因',
    
    // 操作ボタン
    refreshData: 'データ更新',
    exportData: 'データエクスポート',
    viewDetails: '詳細表示',
    
    // 時間フォーマット
    timeAgo: '{{time}}前',
    justNow: 'たった今',
    minutesAgo: '{{minutes}}分前',
    hoursAgo: '{{hours}}時間前',
    daysAgo: '{{days}}日前',
    monthsAgo: '{{months}}ヶ月前',
    yearsAgo: '{{years}}年前',
    
    // 统计弹窗相关翻译
    userStatistics: 'ユーザー統計',
    overview: '概要',
    gameTags: 'ゲームタグ',
    historicalTrend: '履歴トレンド',
    
    // 概览页面
    userOverview: 'ユーザー概要',
    daysData: '{{days}}日データ',
    matchScore: 'マッチスコア',
    totalFollowers: 'フォロワー総数',
    avgViewers30: '30日平均視聴者',
    totalGameTags: 'ゲームタグ総数',
    
    // 用户信息
    userInfo: 'ユーザー情報',
    username: 'ユーザー名',
    registrationTime: '登録時間',
    userStatus: 'ユーザーステータス',
    region: '地域',
    lastLogin: '最終ログイン',
    languagePreference: '言語設定',
    platformBinding: 'プラットフォーム連携',
    active: 'アクティブ',
    inactive: '非アクティブ',
    noInfo: '情報なし',
    bound: '{{count}}/4プラットフォーム連携済み',
    excellent: '優秀',
    good: '良好',
    few: '少ない',
    unbound: '未連携',
    noPlatformsBound: 'プラットフォーム未連携',
    
    // Twitch数据
    twitchData: 'Twitchデータ',
    twitchUsername: 'Twitchユーザー名',
    totalFollowers: 'フォロワー総数',
    accv30: '30日ACCV',
    accv60: '60日ACCV',
    accv90: '90日ACCV',
    fanConversionRate: 'ファンコンバージョン率',
    lastUpdated: '最終更新',
    conversionRateDesc: '30日平均視聴者数 ÷ フォロワー総数',
    noTwitchInfo: 'Twitch情報なし',
    
    // 游戏标签概览
    gameTagsOverview: 'ゲームタグ概要',
    gameGenres: 'ゲームジャンル',
    gameThemes: 'ゲームテーマ',
    highestWeightTag: '最高重みタグ',
    dataRange: 'データ範囲',
    avgMatchRate: '平均マッチ率',
    
    // 数据趋势
    accvTimeTrend: 'ACCV時間トレンド',
    accvTrendDesc: '異なる時間範囲での平均同時視聴者数の比較',
    viewerDataAnalysis: '視聴者データ分析',
    viewerAnalysisDesc: 'フォロワーベースと視聴者アクティビティの分析',
    currentFollowers: '現在のフォロワー数',
    avgViewers30Day: '30日視聴者',
    conversionRate: 'コンバージョン率',
    dataInterpretation: 'データ解釈：',
    conversionRateFormula: '• コンバージョン率 = 30日平均視聴者数 ÷ フォロワー総数 × 100%',
    conversionRateIndicator: '• コンバージョン率が高いほどフォロワーエンゲージメントが良い',
    viewerTrendDesc: '• 視聴者トレンドは異なる期間での配信パフォーマンスを反映',
    conversionRateEvaluation: 'コンバージョン率評価',
    excellentConversion: '✅ 優秀なコンバージョン率',
    goodConversion: '⚠️ 良好なコンバージョン率',
    lowConversion: '❌ 低いコンバージョン率',
    
    // 趋势分析
    trendAnalysis: 'トレンド分析',
    continuousUptrend: '📈 継続的な上昇トレンド、優秀なパフォーマンス',
    continuousDowntrend: '📉 継続的な下降トレンド、注意が必要',
    recentImprovement: '📊 最近のパフォーマンス改善、期待できる',
    recentDecline: '📊 最近のパフォーマンス低下、最適化を推奨',
    relativelyStable: '📊 比較的安定したパフォーマンス',
    
    // 主播评价概览
    streamerRatingOverview: 'ストリーマー評価概要',
    activityRating: 'アクティビティ評価',
    executionRating: '実行力評価',
    costEffectRating: 'コストパフォーマンス評価',
    
    // 游戏标签页面
    tagStatsOverview: 'タグ統計概要',
    gameGenres: 'ゲームジャンル',
    gameThemes: 'ゲームテーマ',
    totalWeight: '総重み',
    avgMatchRate: '平均マッチ率',
    gameGenreDistribution: 'ゲームジャンル分布',
    gameThemeDistribution: 'ゲームテーマ分布',
    tags: 'タグ',
    genreTagDetails: 'ジャンルタグ詳細',
    themeTagDetails: 'テーマタグ詳細',
    weight: '重み',
    match: 'マッチ',
    tagWeightRanking: 'タグ重みランキング',
    top: 'トップ',
    topN: 'トップ{{count}}',
    noTagData: 'タグデータなし',
    expand: '展開',
    collapse: '折りたたみ',
    
    // 游戏列表
    gameList: 'ゲームリスト',
    games: 'ゲーム',
    gameName: 'ゲーム名',
    playTime: 'プレイ時間',
    releaseTime: 'リリース時間',
    dataSyncTime: 'データ同期時間',
    clickToVisitIGDB: 'IGDBゲームページにアクセス',
    noGameData: 'ゲームデータなし',
    noGameRecords: 'このユーザーは{{days}}日間にゲーム記録がありません',
    
    // 游戏统计
    gameStatsOverview: 'ゲーム統計概要',
    totalGames: 'ゲーム総数',
    totalPlayTime: '総プレイ時間',
    avgPlayTime: '平均プレイ時間',
    recentNewGames: '最近1年の新ゲーム',
    
    // 历史趋势页面
    historicalTrendAnalysis: '履歴トレンド分析',
    historicalTrendDesc: '異なる時期のユーザーACCVデータ比較を表示し、パフォーマンストレンドの理解に役立ちます。',
    accvDataOverview: 'ACCVデータ概要',
    dayAverage: '{{days}}日平均',
    audienceFollowerData: '視聴者フォロワーデータ',
    dataExplanation: 'データ説明',
    accvTimeComparison: 'ACCV時間比較',
    dataDetails: 'データ詳細',
    timeRange: '時間範囲',
    relativeChange: '相対変化',
    dataStatus: 'データステータス',
    baseline: 'ベースライン',
    hasData: 'データあり',
    noData: 'データなし',
    dataNote: 'データ注意',
    dataNote1: '• ACCV (Average Concurrent Viewers): 平均同時視聴者数、ストリーマーの影響力を反映',
    dataNote2: '• 現在システムは30日、60日、90日のACCVデータを記録',
    dataNote3: '• ファンコンバージョン率 = 30日平均視聴者数 ÷ フォロワー総数、高い値はファンエンゲージメントが良い',
    dataNote4: '• 相対変化は30日データをベースラインとし、正の値は過去のパフォーマンスが良く、負の値は最近の改善を示す',
    
    // 时间格式
    minutes: '分',
    hours: '時間',
    days: '日',
    unknown: '不明',
    notSynced: '未同期',
    
    // 数字格式
    thousandAbbrev: 'K',
    millionAbbrev: 'M',
    billionAbbrev: 'B',
  },
  ko: {
    // 筛选相关
    timeRange: '시간 범위:',
    game: '게임:',
    allGames: '모든 게임',
    sort: '정렬:',
    search: '검색:',
    searchPlaceholder: '사용자명 또는 Twitch 사용자명 검색...',
    more: '더보기',
    loadingStreamerData: '스트리머 데이터 로딩 중...',
    gameTags: '게임 태그',
    gameType: '게임 유형:',
    gameTheme: '게임 테마:',
    addType: '유형 추가',
    addTheme: '테마 추가',

    // 用户列表相关
    userList: '사용자 목록 ({{count}}명)',
    selectedUsers: '- {{count}}명 선택됨',
    oneClickSelect: '원클릭 선택',
    addToPackage: '스트리머 패키지에 추가',
    clearSelection: '선택 해제',

    // 排序选项
    matchScore: '매치 점수',
    activityLevel: '활동 수준',
    executionAbility: '실행 능력',
    costEffectiveness: '비용 효율성',
    followers: '팔로워',
    avgViewers: '평균 시청자',

    // 主播类型
    unlimited: '무제한',
    premiumStreamer: '프리미엄 스트리머',
    potentialStreamer: '잠재력 스트리머',
    normalStreamer: '일반 스트리머',
    otherStreamers: '기타 스트리머',

    // 评价标签
    activity: '활동성',
    execution: '실행력',
    costEffect: '비용 효과',
    noRating: '평가 없음',

    // 消息
    loadingUsers: '사용자 데이터 로딩 중...',
    noUsers: '일치하는 사용자를 찾을 수 없습니다',
    addedToSelection: '현재 페이지에서 {{count}}명의 사용자를 선택 목록에 추가했습니다',
    clearedSelection: '{{count}}명의 사용자 선택을 해제했습니다',

    // 语言相关
    languageSettings: '언어 설정',
    interfaceLanguage: '인터페이스 언어',
    contentLanguage: '콘텐츠 언어',
    autoDetect: '자동 감지',
  },

  // 添加韩文翻译
  language: '언어',
  streamerFilterSystem: '스트리머 필터 시스템',
  streamerGroupManagement: '스트리머 그룹 관리',
  streamerPackageSystem: '스트리머 패키지 관리 시스템',
  groupList: '그룹 목록',
  addGroup: '그룹 추가',
  loadingGroups: '그룹을 로딩 중...',
  noGroups: '그룹 데이터가 없습니다',
  memberCount: '{{count}}명',
  edit: '편집',
  delete: '삭제',
  days: '일',
  tags: '태그',
  noTags: '태그 없음',
  search: '검색',
  rowsPerPage: '페이지당 행 수:',
  displayedRows: '{{from}}-{{to}} / {{count}}',
  close: '닫기',
  current: '현재',

  // 时间范围
  '30days': '30일',
  '60days': '60일',
  '90days': '90일',
  '120days': '120일',
  '365days': '365일',
  'days': '일',

  // 筛选相关
  timeRange: '시간 범위:',
  game: '게임:',
  allGames: '모든 게임',
  sort: '정렬:',
  search: '검색:',
  searchPlaceholder: '사용자명 또는 Twitch 사용자명 검색...',
  more: '더보기',
  gameTags: '게임 태그',
  gameType: '게임 유형:',
  gameTheme: '게임 테마:',
  addType: '유형 추가',
  addTheme: '테마 추가',

  // 排序选项
  matchScore: '매치 점수',
  activityLevel: '활동 수준',
  executionAbility: '실행 능력',
  costEffectiveness: '비용 효율성',
  followers: '팔로워',
  avgViewers: '평균 시청자',

  // 主播类型
  streamerType: '스트리머 유형:',
  unlimited: '무제한',
  premiumStreamer: '프리미엄 스트리머',
  potentialStreamer: '잠재력 스트리머',
  normalStreamer: '일반 스트리머',
  otherStreamers: '기타 스트리머',

  // 卡片内容
  followersLabel: '팔로워',
  activity: '활동성',
  execution: '실행력',
  costEffect: '비용 효과',
  matchDegree: '매치도',
  noRating: '평가 없음',

  // 搜索按钮
  searchBtn: '검색',

  // More 菜单项
  syncStreamerRatings: '스트리머 평가 동기화',
  syncGameTags: '게임 태그 동기화',
  syncGameInfo: '게임 정보 동기화',

  // 只添加真正缺失的翻译
  addToStreamerPackage: '스트리머 패키지에 추가',
  selectedUsersCount: '{{count}}명 선택됨',
  currentFilters: '현재 필터',
  clearAllFilters: '모든 필터 지우기',
  match: '매치도',
  viewStats: '통계 보기',
  noRatingData: '평가 데이터 없음',
  unknownUser: '알 수 없는 사용자',
  items: '항목',

  // 添加平台用户相关翻译
  platformUsers: '플랫폼 사용자',
  platformUsersDesc: '플랫폼에서 인증되고 관리되는 사용자',
  onlyShowPlatformUsers: '플랫폼 사용자만 표시',
  allUsers: '모든 사용자',

  // 数据加载页面
  loadingStreamerGroupData: '스트리머 그룹 데이터 로딩 중...',
  loadingLatestGroupInfo: '잠시만 기다려주세요. 최신 그룹 및 스트리머 정보를 가져오고 있습니다',

  // 左侧栏
  streamers: '스트리머',
  streamer: '스트리머',
  streamersCount: '{{count}}명의 스트리머',
  streamerCount: '{{count}}명의 스트리머',

  // 自动生成相关
  autoGenerateDefaultGroups: '기본 그룹 자동 생성',
  autoGenerateDefaultGroupsAndPackages: '기본 그룹 및 패키지 자동 생성',
  thisOperationWillCreate: '이 작업은 모든 적격 게임에 대해 기본 그룹과 패키지를 자동으로 생성합니다.',
  onlyCreateForGamesWithoutDefault: '• 기본 그룹이 없는 게임에만 새 그룹 생성',
  onlyCreateForGroupsWithoutDefault: '• 기본 패키지가 없는 그룹에만 새 패키지 생성',
  onlyProcessActiveGamesWithTwitch: '• 상태가 "active"이고 nameInTwitch가 있는 게임만 처리',
  operationCannotBeUndone: '⚠️ 이 작업은 취소할 수 없습니다. 신중하게 진행해주세요',
  cancel: '취소',
  startGeneration: '생성 시작',
  generating: '생성 중...',
  autoGeneratingGroupsAndPackages: '그룹과 패키지를 자동 생성 중...',
  thisCouldTakeMinutes: '잠시만 기다려주세요. 몇 분이 걸릴 수 있습니다',
  
  // 生成结果
  generationResults: '생성 결과',
  processedGames: '처리된 게임 수:',
  createdGroups: '생성된 그룹 수:',
  createdPackages: '생성된 패키지 수:',
  successfullyProcessed: '성공적으로 처리됨:',
  failedProcessed: '처리 실패:',
  successRate: '성공률: {{rate}}',
  operator: '운영자: {{username}}',
  completed: '완료',

  // 主播包相关
  packageBasicInfo: '기본 정보',
  packageName: '패키지 이름',
  enterPackageName: '패키지 이름을 입력하세요...',
  packageDescription: '패키지 설명',
  enterPackageDescription: '패키지 설명을 입력하세요...',
  packageSettings: '패키지 설정',
  maxStreamers: '최대 스트리머 수',
  priority: '우선순위',
  higherNumberHigherPriority: '숫자가 클수록 우선순위가 높음',
  visibilityLevel: '가시성 수준',
  tags: '태그',
  enterTagsCommaSeparated: '태그를 쉼표로 구분하여 입력',
  tagsExample: '예: 프리미엄, 인기, 초보자',
  streamerManagement: '스트리머 관리',
  currentlySelected: '현재 {{count}}명의 스트리머가 선택됨',
  streamerListAutoGenerated: '* 스트리머 목록은 패키지 설정과 필터 조건에 따라 자동 생성됩니다',

  // 删除确认
  confirmDeletePackage: '패키지 삭제 확인',
  confirmDeletePackageMessage: '패키지 "{{name}}"을(를) 삭제하시겠습니까?',
  cannotUndoOperation: '⚠️ 이 작업은 취소할 수 없으며, 패키지의 모든 스트리머 데이터가 삭제됩니다',
  deleting: '삭제 중...',
  confirmDelete: '삭제 확인',

  // 其他状态文本
  processing: '처리 중...',
  public: '공개',
  private: '비공개',
  restricted: '제한됨',
  create: '생성',
  update: '업데이트',
  refreshing: '새로고침 중...',

  // 数据加载相关
  loadedStreamersSuccess: '{{count}}명의 스트리머를 성공적으로 로드했습니다',
  loadedStreamerSuccess: '{{count}}명의 스트리머를 성공적으로 로드했습니다',
  loadDataFailed: '데이터 로드에 실패했습니다',
  networkRequestFailed: '네트워크 요청이 실패했습니다',

  // Twitch 관련 번역
  openTwitchPage: 'Twitch 페이지 열기',
  openSullyGnomeDataPage: 'SullyGnome 데이터 페이지 열기',
  visitTwitchPage: '{{username}}의 Twitch 페이지 방문',
  noTwitchInfo: 'Twitch 정보 없음',
  
  // 통계 다이얼로그 관련 번역
  userStatistics: '사용자 통계',
  basicInfo: '기본 정보',
  gamePreferences: '게임 선호도',
  accountInfo: '계정 정보',
  username: '사용자명',
  displayName: '표시 이름',
  registrationDate: '등록일',
  lastActive: '마지막 활동',
  accountType: '계정 유형',
  verificationStatus: '인증 상태',
  verified: '인증됨',
  unverified: '미인증',
  
  // Twitch 정보
  twitchInfo: 'Twitch 정보',
  twitchUsername: 'Twitch 사용자명',
  twitchFollowers: 'Twitch 팔로워',
  twitchViews: '총 조회수',
  twitchCreatedAt: 'Twitch 생성일',
  averageViewers: '평균 시청자',
  peakViewers: '최고 시청자',
  
  // 게임 태그
  gameTagsWeights: '게임 태그 가중치',
  genreTags: '장르 태그',
  themeTags: '테마 태그',
  tagWeight: '가중치',
  noGameTags: '게임 태그가 없습니다',
  
  // 스트리머 평가
  streamerRatings: '스트리머 평가',
  activityRating: '활동 평가',
  completionRating: '완료 평가',
  costEffectivenessRating: '비용 효율성 평가',
  ratingCode: '평가 코드',
  ratingDescription: '설명',
  lastUpdated: '마지막 업데이트',
  noRatingsAvailable: '평가 데이터가 없습니다',
  
  // 통계 데이터
  statisticsData: '통계 데이터',
  accvHistory: 'ACCV 히스토리 (최근 30일)',
  followerGrowth: '팔로워 성장 추세',
  viewersCount: '시청자 수',
  followersCount: '팔로워 수',
  day: '일',
  date: '날짜',
  
  // 데이터 상태
  dataNotAvailable: '데이터 사용 불가',
  loadingData: '데이터 로딩 중...',
  noDataToDisplay: '표시할 데이터가 없습니다',
  
  // 매치도 관련
  matchAnalysis: '매치도 분석',
  matchScore: '매치도',
  matchFactors: '매치 요인',
  
  // 조작 버튼
  refreshData: '데이터 새로고침',
  exportData: '데이터 내보내기',
  viewDetails: '세부사항 보기',
  
  // 시간 형식
  timeAgo: '{{time}} 전',
  justNow: '방금',
  minutesAgo: '{{minutes}}분 전',
  hoursAgo: '{{hours}}시간 전',
  daysAgo: '{{days}}일 전',
  monthsAgo: '{{months}}개월 전',
  yearsAgo: '{{years}}년 전',
  
  // 统计弹窗相关翻译
  userStatistics: '사용자 통계',
  overview: '개요',
  gameTags: '게임 태그',
  historicalTrend: '히스토리 트렌드',
  
  // 概览页面
  userOverview: '사용자 개요',
  daysData: '{{days}}일 데이터',
  matchScore: '매치 점수',
  totalFollowers: '총 팔로워 수',
  avgViewers30: '30일 평균 시청자',
  totalGameTags: '게임 태그 총수',
  
  // 用户信息
  userInfo: '사용자 정보',
  username: '사용자명',
  registrationTime: '등록 시간',
  userStatus: '사용자 상태',
  region: '지역',
  lastLogin: '마지막 로그인',
  languagePreference: '언어 설정',
  platformBinding: '플랫폼 연동',
  active: '활성',
  inactive: '비활성',
  noInfo: '정보 없음',
  bound: '{{count}}/4 플랫폼 연동됨',
  excellent: '우수',
  good: '양호',
  few: '적음',
  unbound: '미연동',
  noPlatformsBound: '플랫폼 미연동',
  
  // Twitch数据
  twitchData: 'Twitch 데이터',
  twitchUsername: 'Twitch 사용자명',
  totalFollowers: '총 팔로워 수',
  accv30: '30일 ACCV',
  accv60: '60일 ACCV',
  accv90: '90일 ACCV',
  fanConversionRate: '팬 전환율',
  lastUpdated: '마지막 업데이트',
  conversionRateDesc: '30일 평균 시청자수 ÷ 총 팔로워수',
  noTwitchInfo: 'Twitch 정보 없음',
  
  // 游戏标签概览
  gameTagsOverview: '게임 태그 개요',
  gameGenres: '게임 장르',
  gameThemes: '게임 테마',
  highestWeightTag: '최고 가중치 태그',
  dataRange: '데이터 범위',
  avgMatchRate: '평균 매치율',
  
  // 数据趋势
  accvTimeTrend: 'ACCV 시간 트렌드',
  accvTrendDesc: '다른 시간 범위의 평균 동시 시청자 수 비교',
  viewerDataAnalysis: '시청자 데이터 분석',
  viewerAnalysisDesc: '팔로워 기반과 시청자 활동 분석',
  currentFollowers: '현재 팔로워 수',
  avgViewers30Day: '30일 시청자',
  conversionRate: '전환율',
  dataInterpretation: '데이터 해석:',
  conversionRateFormula: '• 전환율 = 30일 평균 시청자 수 ÷ 총 팔로워 수 × 100%',
  conversionRateIndicator: '• 높은 전환율은 더 나은 팔로워 참여를 나타냄',
  viewerTrendDesc: '• 시청자 트렌드는 다른 기간의 스트리밍 성과를 반영',
  conversionRateEvaluation: '전환율 평가',
  excellentConversion: '✅ 우수한 전환율',
  goodConversion: '⚠️ 양호한 전환율',
  lowConversion: '❌ 낮은 전환율',
  
  // 趋势分析
  trendAnalysis: '트렌드 분석',
  continuousUptrend: '📈 지속적인 상승 트렌드, 우수한 성과',
  continuousDowntrend: '📉 지속적인 하강 트렌드, 주의 필요',
  recentImprovement: '📊 최근 성과 개선, 유망함',
  recentDecline: '📊 최근 성과 하락, 최적화 제안',
  relativelyStable: '📊 상대적으로 안정적인 성과',
  
  // 主播评价概览
  streamerRatingOverview: '스트리머 평가 개요',
  activityRating: '활동 평가',
  executionRating: '실행력 평가',
  costEffectRating: '비용 효과 평가',
  
  // 游戏标签页面
  tagStatsOverview: '태그 통계 개요',
  gameGenres: '게임 장르',
  gameThemes: '게임 테마',
  totalWeight: '총 가중치',
  avgMatchRate: '평균 매치율',
  gameGenreDistribution: '게임 장르 분포',
  gameThemeDistribution: '게임 테마 분포',
  tags: '태그',
  genreTagDetails: '장르 태그 상세',
  themeTagDetails: '테마 태그 상세',
  weight: '가중치',
  match: '매치',
  tagWeightRanking: '태그 가중치 랭킹',
  top: '상위',
  topN: '상위{{count}}',
  noTagData: '태그 데이터 없음',
  expand: '확장',
  collapse: '접기',
  
  // 游戏列表
  gameList: '게임 목록',
  games: '게임',
  gameName: '게임 이름',
  playTime: '플레이 시간',
  releaseTime: '출시 시간',
  dataSyncTime: '데이터 동기화 시간',
  clickToVisitIGDB: 'IGDB 게임 페이지 방문',
  noGameData: '게임 데이터 없음',
  noGameRecords: '이 사용자는 {{days}}일 동안 게임 기록이 없습니다',
  
  // 游戏统计
  gameStatsOverview: '게임 통계 개요',
  totalGames: '총 게임 수',
  totalPlayTime: '총 플레이 시간',
  avgPlayTime: '평균 플레이 시간',
  recentNewGames: '최근 1년 신작 게임',
  
  // 历史趋势页面
  historicalTrendAnalysis: '히스토리 트렌드 분석',
  historicalTrendDesc: '다른 시간대의 사용자 ACCV 데이터 비교를 표시하여 성과 트렌드 이해에 도움.',
  accvDataOverview: 'ACCV 데이터 개요',
  dayAverage: '{{days}}일 평균',
  audienceFollowerData: '시청자 팔로워 데이터',
  dataExplanation: '데이터 설명',
  accvTimeComparison: 'ACCV 시간 비교',
  dataDetails: '데이터 상세',
  timeRange: '시간 범위',
  relativeChange: '상대 변화',
  dataStatus: '데이터 상태',
  baseline: '기준선',
  hasData: '데이터 있음',
  noData: '데이터 없음',
  dataNote: '데이터 주의사항',
  dataNote1: '• ACCV (Average Concurrent Viewers): 평균 동시 시청자 수, 스트리머의 영향력 반영',
  dataNote2: '• 현재 시스템은 30일, 60일, 90일 ACCV 데이터 기록',
  dataNote3: '• 팬 전환율 = 30일 평균 시청자 수 ÷ 총 팔로워 수, 높은 값은 더 나은 팬 참여를 나타냄',
  dataNote4: '• 상대 변화는 30일 데이터를 기준으로 하며, 양수는 과거 성과가 더 좋음을, 음수는 최근 개선을 나타냄',
  
  // 时间格式
  minutes: '분',
  hours: '시간',
  days: '일',
  unknown: '알 수 없음',
  notSynced: '미동기화',
  
  // 数字格式
  thousandAbbrev: 'K',
  millionAbbrev: 'M',
  billionAbbrev: 'B',
};

// 新增：获取多语言文本的函数
export const getMultilingualText = (key, language = 'en', params = {}) => {
  const texts = MULTILINGUAL_TEXTS[language] || MULTILINGUAL_TEXTS.en;
  let text = texts[key] || key;

  // 简单的参数替换
  Object.keys(params).forEach(param => {
    text = text.replace(`{{${param}}}`, params[param]);
  });

  return text;
};

// 原有的函数保持不变
const languages = lang => (langObj[lang] ? langObj[lang] : lang);

export default languages;